/* eslint-disable */
import {
  Button,
  Form,
  Col,
  Row,
  Container,
  Badge,
  Spinner,
  Alert,
  Nav,
  InputGroup,
} from "react-bootstrap";

import { useEffect, useState, useCallback, useRef } from "react";

import { useParams, useNavigate, useLocation } from "react-router-dom";

import DatePicker from "react-datepicker";

import "./ProblemForm.css";

import "react-datepicker/dist/react-datepicker.css";

import Select from "react-select";
import PageLeadership from "../PageLeadership";

import { isBefore, isAfter, startOfDay, subMinutes } from "date-fns";
import { ComponentAPI } from "../../connections/fetchStatusPageComponents";
import { BrandsAPI } from "../../connections/Brands";
import { NotesAPI } from "../../connections/Notes";
// Generated by GitHub Copilot
// Removed EscalationAPI import - business liaison workflows now generated in backend
import { TemplateAPI } from "../../connections/fetchTemplates";
// Generated by GitHub Copilot
import { authFetch } from "../../utils/authFetch";
import {
  buildSendCommunicationPayload,
  buildPeerReviewPayload,
} from "./sendCommsPayload";

// Generated by GitHub Copilot

import { FormatComms } from "./FormatComms";
import NotesTab from "../Tabs/Notes";
import VersionHistory from "../VersionHistory";
// Generated by GitHub Copilot
import StatusPageSelector from "../StatusPageSelector";
// Generated by GitHub Copilot
import LeftNavigation from "../LeftNavigation/LeftNavigation";
import UnsavedNumberModal from "./UnsavedNumberModal";
import {
  isUnsavedPrbtNumber,
  rewriteProblemNumberInPath,
} from "../../utils/unsavedNumberGuard";

// Generated by GitHub Copilot - Story 08: Simplified Auto-Save (PATCH only)
import { useFieldAutoSave } from "../../hooks/useFieldAutoSave";

import {
  affectedUserOptions,
  statusOptions,
  priorityOptions,
} from "../../common/Options/Options";

import {
  FaFloppyDisk,
  FaPager,
  FaUserSecret,
  FaUserPen,
  FaMeteor,
  FaComment,
  FaBook,
  FaHashtag,
  FaCalendarDay,
  FaUsers,
  FaSlack,
  FaAws,
  FaSalesforce,
  FaDumpsterFire,
  FaTriangleExclamation,
  FaSkullCrossbones,
  FaSkull,
  FaRadiation,
} from "react-icons/fa6";

import { FaHistory } from "react-icons/fa";

import { HiExclamationTriangle } from "react-icons/hi2";

import CreatableMenu from "../CreateMenu/index.js";
import dayjs from "dayjs";

import { ReportingAccordion } from "../ReportingAccordion";
import Modal from "react-bootstrap/Modal";
import { CommunicationAPI } from "../../connections/communication";
import ImpactReportsViewer from "../Viewer/ImpactReportsViewer";
import { LightModeLayout } from "../Layout/LightModeLayout";
// US1873550: Import impactService for fetching reported impacts on the comms tab.
import { impactService } from "../../services/impactService";
import { capitalize } from "../../utils/textFormatters";
import ResolvePeakConfirm from "../Modern/ConfirmationModal/ResolvePeakConfirm";
import SlackCardPreview from "../Modern/Communications/SlackCardPreview";
// US2083214: the Page tab needs to know whether the outage's PagerDuty id is one
// PagerDuty actually has, so an invalid one can be swapped for a working one.
import usePagerDutyActivity from "../../hooks/usePagerDutyActivity";
import {
  RESOLVE_STATUS,
  isReopen,
  shouldOpenResolveModal,
} from "./statusGateHelpers";
import {
  shouldShowNoIncidentLinked,
  isPermanentTargetNumber,
  shouldForwardToPermanent,
  NO_COMMAND_CENTER_INCIDENT_MESSAGE,
} from "../../utils/incidentLinkage";

const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

const createOption = (label) => ({
  label,
  value: label,
});


/**
 * US2097708 (D8): turn an autosave fieldPath into something an operator can read, for the inline
 * rejection alert. Field paths reach the UI as raw wire names ("message_for_clients") and nested
 * ones as dotted paths ("outages.OUT123.priority"), so the last segment is the field and the
 * prefix is addressing. Returns null for anything unusable so the caller can omit the label
 * rather than render "undefined".
 *
 * @param {string} fieldPath - The autosave field path from the error object
 * @returns {string|null} A human-readable field name, or null
 */
const autoSaveFieldLabel = (fieldPath) => {
  if (typeof fieldPath !== "string" || !fieldPath.trim()) {
    return null;
  }
  const leaf = fieldPath.trim().split(".").pop();
  return leaf ? leaf.replace(/_/g, " ") : null;
};

const dateFormat = "MM/dd/yyyy hh:mm a";

const previewDateFormat = "MM/DD/YYYY hh:mm a";

const cs = {
  half: 5,
  third: 4,
  quarter: 3,
  full: 10,
  most: 8,
};

// US2092239: actionable text per api-standard error code
// (docs/standards/api-standards.md §7). The backend resolve gate returns
// {"error":{"code","message"}} with one of these codes; branching on the code —
// never on the prose — is what lets the UI tell the MIM what to DO next rather
// than echoing a raw "PATCH failed (400)".
// Codes are SCREAMING_SNAKE_CASE, matching the convention shared by every
// writeAPIError caller on the backend.
// US2092239: the "Reload the page" step is REQUIRED, not politeness. The local
// optimistic write is not reverted (see onError), so after a rejected resolve
// outage.status is still "Resolve" locally — and shouldOpenResolveModal keys on
// prevStatus !== RESOLVE_STATUS, so re-selecting Resolve does NOT reopen the
// confirmation modal. A reload re-reads the server state (still un-resolved,
// since the PATCH failed), which re-arms the gate. Omitting "reload" would
// instruct the MIM to perform an action that cannot work.
const FIELD_SAVE_ERROR_MESSAGES = {
  MISSING_CONFIRMED_PEAK_PRIORITY:
    "Resolve was not saved: the peak priority was not confirmed. Reload the page, then set Status to Resolve again and confirm the highest EP level reached (EP1–EP4).",
  INVALID_CONFIRMED_PEAK_PRIORITY:
    "Resolve was not saved: the confirmed peak priority was not a valid EP level. Reload the page, then set Status to Resolve again and select EP1, EP2, EP3 or EP4.",
};

// US2092239: build the message shown to the MIM for a failed field save. Prefers
// the code-specific actionable text, falls back to the server's own message, and
// finally to a generic line — so an unrecognized or plain-text error is still
// reported rather than silently swallowed.
const deriveFieldSaveErrorMessage = (err, fieldPath) => {
  const known = FIELD_SAVE_ERROR_MESSAGES[err?.code];
  if (known) return known;
  const label = fieldPath === "incident_end" ? "Impact End" : "Status";
  const detail = err?.message ? ` (${err.message})` : "";
  // US2092239: the local edit is NOT reverted (see onError), so this must not
  // claim it was — reload to see the persisted value.
  return `${label} was not saved. Reload the page to see the saved value, then try again.${detail}`;
};

// US2097708: copy for a refused save whose error carries no message of its own. Kept as a
// named constant because a test asserts the real server message REPLACES it rather than
// being appended to it.
const REFUSED_FIELD_SAVE_FALLBACK_MESSAGE =
  "This change could not be saved. Reload the record and try again.";

// US2097708: normalize a field path to the key the refused-save list is built on. Absent,
// non-string and whitespace-only paths all collapse to "" — exactly the inputs
// autoSaveFieldLabel returns null for — so one unattributable failure is ONE entry rather
// than one entry per falsy shape.
const refusedFieldSaveKey = (fieldPath) =>
  typeof fieldPath === "string" ? fieldPath.trim() : "";

/**
 * US2097708 + US2092239: collapse every "this field's save was refused" source into ONE
 * ordered, per-field list — the single error banner's only input.
 *
 * Two sources, deliberately, because they cover different fields:
 *  - the hook's own `error`/`errors` reach EVERY autosaved field, carrying the server's
 *    own prose (a 409 promoted_record_write_refused refuses every field in turn);
 *  - `fieldSaveErrors` (projected from fieldSaveErrorsRef) covers only "status" and
 *    "incident_end" — onError returns early for anything else — but carries the
 *    code-keyed instruction from deriveFieldSaveErrorMessage that says what to DO next.
 *
 * Order follows the hook, so the rendered list reads in the order the hook reports its
 * failures. Dedup is by field path and `fieldSaveErrors` wins the message for the fields
 * it knows: `Map.set` on an existing key overwrites the value while KEEPING the field's
 * original position, so preferring the actionable wording never reorders the list.
 *
 * @param {Object} sources
 * @param {string} sources.autoSaveStatus - Hook save status
 * @param {{message?: string, fieldPath?: string}|null} sources.autoSaveError - Hook's newest failure
 * @param {Array<{message?: string, fieldPath?: string}>} sources.autoSaveErrors - Every hook failure
 * @param {Array<{fieldPath: string, message: string}>} sources.fieldSaveErrors - Status/Impact End failures
 * @returns {Array<{fieldPath: string, message: string}>} One entry per refused field
 */
const collectRefusedFieldSaves = ({
  autoSaveStatus,
  autoSaveError,
  autoSaveErrors,
  fieldSaveErrors,
}) => {
  const byFieldPath = new Map();
  const addIfNew = (fieldPath, message) => {
    const key = refusedFieldSaveKey(fieldPath);
    if (byFieldPath.has(key)) return;
    byFieldPath.set(key, {
      fieldPath: key,
      message: message || REFUSED_FIELD_SAVE_FALLBACK_MESSAGE,
    });
  };

  autoSaveErrors.forEach((entry) => addIfNew(entry?.fieldPath, entry?.message));
  // The newest failure is normally already in `errors`; this covers the callers (and the
  // pre-F1 test mocks) that surface only the single `error`.
  if (autoSaveStatus === "error" && autoSaveError) {
    addIfNew(autoSaveError.fieldPath, autoSaveError.message);
  }
  fieldSaveErrors.forEach(({ fieldPath, message }) => {
    const key = refusedFieldSaveKey(fieldPath);
    byFieldPath.set(key, { fieldPath: key, message });
  });

  return Array.from(byFieldPath.values());
};

function ProblemForm(props) {
  // Generated by GitHub Copilot
  // Extract configuration from props (loaded centrally in App.js)
  const { configuration: appConfiguration, user, NewRelic } = props;

  let params = useParams();
  const location = useLocation();

  // const vendorOptions = [{ label: "AWS", value: "aws" }];

  const [communications, setCommunications] = useState([]);

  const [saved, setSaved] = useState(true);

  const [problem, setProblem] = useState({ outages: [] });

  const [versionCount, setVersionCount] = useState(0);

  // Generated by GitHub Copilot
  const versionHistoryRef = useRef();

  const [outage, setOutage] = useState({
    impactedApplications: [],
  }); // es-lint-disable no-unused-vars

  const [loaded, setLoaded] = useState(true);
  const [incidentStart, setIncidentStart] = useState();
  const [incidentEnd, setIncidentEnd] = useState();
  // US2028896: system-computed peak (highest EP reached) from the read payload,
  // and the resolve-time confirmation modal state. pendingResolve describes the
  // resolve awaiting MIM peak-priority confirmation:
  //   { trigger: "status", prevStatus }         — resolve via Status dropdown
  // On confirm it routes to persistStatusResolve; prevStatus is what Cancel
  // reverts the dropdown to. US2092239: the former "end" trigger (resolve via
  // the Impact End picker) is gone — Impact End is now a plain field write — so
  // "status" is the only shape. The discriminated `trigger` is retained because
  // the confirmation modal is shared and the cancel path keys off it.
  const [computedPeakPriority, setComputedPeakPriority] = useState("");
  // US2028896: holds the latest refreshComputedPeak closure so the memoized
  // handleStatusChange can call it without listing it as a dependency (which
  // would rebuild the callback every render). Assigned below where the helper
  // is defined.
  const refreshComputedPeakRef = useRef(() => Promise.resolve(""));
  // US2028896: Synchronous guard so the shared ConfirmationModal's
  // onConfirm()-then-onClose() sequence does not revert the Status dropdown after
  // a successful confirm. Set true at the start of handleResolvePeakConfirm and
  // consumed by handleResolvePeakCancel (which the modal fires immediately after).
  const resolveConfirmedRef = useRef(false);
  // US2092239 (Finding 6): re-arm the resolve confirmation gate after the
  // backend rejects a resolve.
  //
  // resolveAttemptRef holds `{ prevStatus }` for the status write currently in
  // flight FROM persistStatusResolve — i.e. a resolve. It exists because
  // `pendingResolve` is already null by the time the save's onError runs:
  // handleResolvePeakConfirm calls setPendingResolve(null) before
  // persistStatusResolve, so the pre-resolve status has to be snapshotted here
  // instead. It is also the discriminator that keeps onError honest — it is set
  // ONLY by persistStatusResolve and cleared by every non-resolve status write,
  // so an Impact End failure, or a plain status write that fails, cannot arm the
  // gate.
  //
  // rejectedResolveRef holds `{ prevStatus }` once that resolve has been
  // rejected. handleStatusChange prefers it over `outage.status` when deriving
  // the gate's prevStatus, because the optimistic local write is deliberately
  // not reverted (see onError): outage.status reads "Resolve" locally while the
  // server still holds the prior status, and shouldOpenResolveModal keys on
  // prevStatus !== RESOLVE_STATUS. Without the override, re-selecting Resolve
  // falls straight through the gate into an unconfirmed PATCH and earns a second
  // silent 400, with no in-session way to reprompt.
  //
  // Refs, not state: they are written from the auto-save callbacks (which may
  // belong to an in-flight save captured by an earlier render) and read
  // synchronously inside handleStatusChange before any re-render. They never
  // drive rendering — a derived render value cannot be latched here, only a
  // control-flow decision.
  const resolveAttemptRef = useRef(null);
  const rejectedResolveRef = useRef(null);
  // US2080752: monotonically increasing request id for savePagerDutyIncident.
  // Overlapping saves (key-repeat / paste+blur / fast resubmit) fire concurrent
  // PATCHes; only the response matching the latest id is allowed to commit
  // state/message so a stale response can never clobber a newer one.
  const pagerDutySaveSeqRef = useRef(0);
  // US2080752: last trimmed value a save was initiated for. The save now fires
  // on paste / blur / Enter (not just Enter), and each fire is a LIVE PagerDuty
  // existence API call — so we dedupe by early-returning (no network call) when
  // the current trimmed value equals this ref. This absorbs the redundant fires
  // the broadened triggers produce (paste then blur, repeated blurs, blur after
  // Enter). Reset on disconnect so the same ID can be re-validated.
  const pagerDutyLastSubmittedRef = useRef("");
  // US2097708 (A4): id of the 2s timer that resets numberSaveStatus from
  // "saved" back to "idle". It has to be cancellable: an uncleared timer armed
  // by one save fires in the middle of the NEXT save and flips the status to
  // "idle", which re-enables the save button while its PATCH is still in
  // flight. That is the one case where the button's enabled state stops
  // mirroring saveNumberChange's guard, and a second click is a duplicate
  // rename the promoted-record write guard answers with a 409.
  const numberSaveResetTimerRef = useRef(null);
  // US2097708 (A5): true for exactly as long as a saveNumberChange PATCH is in
  // flight. Two jobs, and it is a ref (not state) for both because both need a
  // value that is correct SYNCHRONOUSLY, before React has re-rendered:
  //   * saveNumberChange early-returns on it, so a second invocation cannot
  //     issue a second concurrent PATCH even if the button's disabled state is
  //     momentarily wrong. apiPatchProblemField does GetProblemByID +
  //     SaveProblem per request with no version check, so two in-flight
  //     renames race last-write-wins on `number` -- the exact corruption this
  //     story exists to prevent.
  //   * onNumberChange checks it before clearing numberSaveStatus, so typing
  //     mid-request cannot flip "saving" back to "idle" and re-enable the
  //     button under the running PATCH.
  const numberSaveInFlightRef = useRef(false);
  // US2097708 (A5): the value the operator typed into the number field WHILE a
  // PATCH was in flight, or null if they did not touch it. Reset at the start
  // of every save and written only inside the in-flight window, so it cannot
  // drift out of sync with `problem` -- it is deliberately NOT a mirror of
  // problem.number.
  //
  // saveNumberChange cannot see mid-flight typing any other way: `problem` is
  // captured from the render that produced the click handler, so problem.number
  // read after the await is the value that was SENT, not what is on screen now
  // (a keystroke re-renders with a new closure; the running invocation keeps
  // the old one). The success path needs the difference, because the A5
  // interlock now deterministically blocks the second PATCH that used to
  // persist the newer value: without this ref it clears numberModified and
  // disables the save button while the field still shows a number the server
  // never received, beside a green success tick.
  //
  // SCOPE: this covers the NON-PROMOTION arm only. The promotion arm below
  // (oldNumber PRBT -> isPermanentTargetNumber) does not consult this ref: it
  // overwrites problem.number with the click-time newNumber, clears
  // numberEditable and navigates, so a mid-flight correction on a promotion is
  // still discarded and the field snaps back to the value that was sent. That
  // arm is byte-identical to main apart from the isPermanentTargetNumber swap,
  // and the window is sub-second, so it is a recorded residual rather than a
  // regression — see the PR's residuals list. Do not read this comment as a
  // guarantee that covers promotion.
  const numberEditedDuringSaveRef = useRef(null);
  const [showResolvePeakConfirm, setShowResolvePeakConfirm] = useState(false);
  const [pendingResolve, setPendingResolve] = useState(null);
  const [eocNotified, setEOCNotified] = useState();
  const [timeDetected, setTimeDetected] = useState();

  const [techTimeResolved, setTechTimeResolved] = useState();
  const [nextUpdate, setNextUpdate] = useState(new Date());

  const [outageNumber, setOutageNumber] = useState("");
  const [impactedApplications, setImpactedApplications] = useState([]);

  const [status, setStatus] = useState(statusOptions[0]);
  const [priorityOption, setPriorityOption] = useState(priorityOptions[0]);
  const [viewLink, setViewLink] = useState();
  const [defaultCommanders, setDefaultCommanders] = useState([]);
  // Generated by GitHub Copilot
  // Use configuration from props instead of local state
  // const [configuration, setConfiguration] = useState({
  //   slack: {},
  //   products: {},
  //   productMatching: {},
  // });

  // Use centralized configuration from App.js
  const configuration = appConfiguration || {
    slack: { channels: [] },
    products: [],
    productMatching: {},
  };

  const [enteredPagerDutyIncident, setEnteredPagerDutyIncident] = useState("");

  const [slackChannels, setSlackChannels] = useState([createOption("None")]);
  const [slack, setSlack] = useState(createOption("none"));

  const [pagerDutyIncident, setpagerDutyIncident] = useState("");

  // US2080752: inline result of the on-Enter PagerDuty save. Shape:
  // { variant: "error" | "warning", text: string } — "error" is the red 400
  // "no incident found" case (input stays visible), "warning" is the amber
  // fail-open "couldn't confirm" case. null = no message.
  const [pagerDutyFieldMessage, setPagerDutyFieldMessage] = useState(null);

  const [commanderOptions, setCommanderOptions] = useState([]);
  const [incidentCommander, setIncidentCommander] = useState();
  const [notes, setNotes] = useState([]);

  const [numberEditable, setNumberEditable] = useState(false);

  // Generated by GitHub Copilot - Track if problem number field has been modified
  const [numberModified, setNumberModified] = useState(false);

  // Generated by GitHub Copilot - Track original problem number for save comparison
  const [originalNumber, setOriginalNumber] = useState("");

  // Generated by GitHub Copilot - Track number save status: 'idle' | 'saving' | 'saved' | 'error'
  const [numberSaveStatus, setNumberSaveStatus] = useState("idle");
  // Server-provided reason a number save was rejected (e.g. an INC that isn't an
  // existing EOC Bridge incident), shown inline beneath the number field.
  const [numberSaveError, setNumberSaveError] = useState("");

  // US2138216: a route change or tab switch held while the MIM decides what to
  // do with an unsaved PRBT number: { destination, tab, proceed }.
  const [pendingExit, setPendingExit] = useState(null);
  // Leave without saving resets the field first; the exit runs once that
  // reset has rendered, so it sees the PRBT and not the discarded value.
  const [exitAfterReset, setExitAfterReset] = useState(null);
  const numberInputRef = useRef(null);
  // The typed-but-unsaved PRBT number, kept so a record refetch does not
  // silently overwrite it and switch the guard off.
  const unsavedNumberDraftRef = useRef(null);
  // The number save in flight, so an exit requested mid-save can wait for its
  // outcome instead of guessing it.
  const numberSavePromiseRef = useRef(null);
  // The tab of a held tab exit. A promoting save reads it when it builds its
  // redirect, because the promotion remounts the form under the new number.
  const heldExitTabRef = useRef(null);
  // Latest switchTab, for exits and the initial load that run after the
  // render that created them.
  const switchTabRef = useRef(() => {});
  const focusNumberOnModalExitRef = useRef(false);
  // A Save and continue that promotes the record remounts this form under the
  // new number (ProblemFormWrapper keys on the id), so a pending tab switch
  // travels on the redirect's location state and is applied once loaded.
  const promotedPendingTabRef = useRef(location.state?.unsavedNumberTab ?? null);
  // Flips once the first load has settled (success or failure) and rendered,
  // so the carried tab's refresh reads loaded state such as outageNumber.
  const [initialLoadSettled, setInitialLoadSettled] = useState(false);
  // US2092239: the rejected Status/Impact End saves, surfaced in the record-level
  // banner. Rendered text only — the authoritative record is fieldSaveErrorsRef below.
  // US2097708: entries `{fieldPath, message}`, not one joined string. The joined string
  // discarded which field each message belonged to, and the single surviving banner needs
  // that to label the message and to list every refused field. Still one slot of state
  // projected from the ref, not a second source of truth.
  const [fieldSaveErrors, setFieldSaveErrors] = useState([]);
  // US2092239: fieldPath → message for EVERY field whose save is currently
  // failed, so ONLY a successful save of a given field can clear that field's
  // message. Status and Impact End are independent writes that can share a
  // cause (an expired session, a 5xx window), so BOTH can be failed at once.
  // A single slot held one fieldPath: the second failure overwrote the first,
  // and a later success on the second field then cleared the banner outright —
  // leaving Status reading "Resolve", no error shown, and an unresolved server
  // record, which is the silently-unresolved state this story exists to remove.
  //
  // A ref (not state) because it is read and mutated inside the auto-save
  // callbacks, which may have been captured by an in-flight save from an
  // earlier render — a ref is always current. It never drives rendering
  // directly; syncFieldSaveError projects it into `fieldSaveErrors`.
  const fieldSaveErrorsRef = useRef(new Map());

  // US2092239 (Finding 1): monotonic count of failure messages RECORDED into
  // fieldSaveErrorsRef. fetchProblemDetails snapshots it when a refresh starts
  // and only clears the map if it is unchanged when the refresh lands, so a save
  // that failed WHILE that (async) refresh was in flight cannot have its message
  // wiped by data fetched before the failure. Same in-flight guard the
  // pagerDutySaveSeqRef/seqAtRefreshStart pair uses in the same function.
  const fieldSaveErrorSeqRef = useRef(0);

  // US2092239: project the failed-field map into the single rendered banner.
  // Insertion-ordered, so the messages read in the order the saves failed.
  // US2097708: project the ENTRIES, keeping each message attached to its own field path.
  // The previous `.join(" ")` ran two messages together into one unattributable
  // paragraph; the banner now labels and lists them (see collectRefusedFieldSaves).
  const syncFieldSaveError = () => {
    setFieldSaveErrors(
      Array.from(fieldSaveErrorsRef.current.entries()).map(
        ([fieldPath, message]) => ({ fieldPath, message }),
      ),
    );
  };

  // Generated by GitHub Copilot
  // Removed deprecated workflow state variables (commanderWorkflows, leaderWorkflows, otherWorkflows)
  // These are now handled through consolidated workflow data from backend

  // Generated by GitHub Copilot
  // State for unexecuted workflow count indicator
  const [unexecutedWorkflowCount, setUnexecutedWorkflowCount] = useState(0);

  const [archived, setArchived] = useState(false);

  // Generated by GitHub Copilot
  const [currentVersion, setCurrentVersion] = useState("");

  const [affectedUserOption, setAffectedUserOption] = useState();

  const [showExternalMessage, setShowExternalMessage] = useState(false);

  const [affectedBrands, setAffectedBrands] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);

  const apiBase = "/api/v1/";

  const problemURL = params.id
    ? apiBase + "problem/" + params.id
    : "problem/" + apiBase;

  const [commanderOverride, setCommanderOverride] = useState(false);

  const [showPagingForm, setShowPagingForm] = useState(false);

  const [missingPagingCriteria, setMissingPagingCriteria] = useState([]);

  const [templateOption, setTemplateOption] = useState();
  const [templateOptions, setTemplateOptions] = useState();

  const [showReportedIssue, setShowReportedIssue] = useState(false);

  const [publishingTargets, setPublishingTargets] = useState([]);

  const [groupOptions, setGroupOptions] = useState([]);

  const [statusBrand, setStatusBrand] = useState();
  const [statusApplications, setStatusApplications] = useState();

  const [reportedIssue, setReportedIssue] = useState("");

  const [slackSmsCommunication, setSlackSmsCommunication] = useState("");

  const [showPreviewModal, setShowPreviewModal] = useState(false);

  // Generated by GitHub Copilot
  // State management for communication sending (US1778407)
  const [isSendingCommunication, setIsSendingCommunication] = useState(false);
  const [isRequestingPeerReview, setIsRequestingPeerReview] = useState(false);
  const [sendError, setSendError] = useState(null);
  const [peerReviewSuccess, setPeerReviewSuccess] = useState(null);

  // US2077763: dismissible notice shown when a field auto-save is rejected with a
  // 409 version conflict (someone else updated this incident). The onConflict
  // handler on useFieldAutoSave re-fetches the latest problem and sets this so the
  // user sees they are now viewing the winning server state. Non-blocking + dismissible.
  const [conflictNotice, setConflictNotice] = useState(null);

  // US1873550: Reported impacts snapshot for the comms composition page.
  const [reportedImpacts, setReportedImpacts] = useState([]);
  const [reportedImpactsLoading, setReportedImpactsLoading] = useState(false);

  // Generated by GitHub Copilot

  const [tabKey, setTabKey] = useState("primary");

  // US2083214: is the PagerDuty id for this outage one PagerDuty actually has?
  //
  // Only the Page tab needs the answer, so the ids are passed as null otherwise —
  // usePagerDutyActivity short-circuits on a falsy id and issues NO request, so
  // this costs nothing on every other tab.
  //
  // The backend answers for the id stored on the outage OR, when that is empty, the
  // one ServiceNow holds for the ticket, so both an invalid stored id and an invalid
  // never-attached one are reported. Only reason === "incident_not_found" counts:
  // that is PagerDuty affirmatively saying no such incident. A PagerDuty outage
  // (fetch_failed) must NOT strip the attached UI, or a transient blip would hide
  // paging mid-incident.
  const pdActivityForTab = usePagerDutyActivity(
    tabKey === "paging" && problem && problem.number ? problem.number : null,
    tabKey === "paging" ? params.outage : null,
    tabKey === "paging"
  );
  const pdIncidentNotFound =
    !!pdActivityForTab.data &&
    pdActivityForTab.data.reason === "incident_not_found";
  const pdInvalidIncidentID = pdIncidentNotFound
    ? pdActivityForTab.data.incidentId
    : "";

  const yesNo = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  // US1989003: track workflow refresh state. workflowsChangedSinceLoad covers ALL fields that
  // drive the workflow list (priority, impacted_applications, affected_brands), not just priority.
  const [workflowsRefreshing, setWorkflowsRefreshing] = useState(false);
  const [workflowsChangedSinceLoad, setWorkflowsChangedSinceLoad] = useState(false);
  const [workflowLoadError, setWorkflowLoadError] = useState(false);

  // US1989003: stable, functional-setter-based refresh — must be declared before useFieldAutoSave
  // so the onSaved callback below can reference it without a stale closure.
  // Deps are [params.id, outageNumber] only; functional setters avoid reading stale state.
  const updateConsolidatedWorkflows = useCallback(async () => {
    setWorkflowLoadError(false);
    try {
      const { WorkflowsAPI } = await import("../../connections/Workflows");
      const consolidatedWorkflows = await WorkflowsAPI.getConsolidated(
        params.id,
        outageNumber,
      );
      setOutage(prev => ({ ...prev, consolidatedWorkflows }));
      setProblem(prev => ({
        ...prev,
        outages: {
          ...prev.outages,
          [outageNumber]: { ...(prev.outages?.[outageNumber] || {}), consolidatedWorkflows },
        },
      }));
      setWorkflowsChangedSinceLoad(false);
      setWorkflowLoadError(false);
    } catch (error) {
      console.error("Failed to update consolidated workflows:", error);
      setWorkflowLoadError(true);
      throw error;
    } finally {
      setWorkflowsRefreshing(false);
    }
  }, [params.id, outageNumber]);

  // US2077763: forward-reference to fetchProblemDetails so the onConflict handler
  // below (declared inside useFieldAutoSave options) can trigger the existing
  // problem refetch without a stale closure. fetchProblemDetails is a useCallback
  // declared LATER in this component; the ref is populated once it exists (see the
  // assignment right after its definition). Mirrors the refreshComputedPeakRef pattern.
  const fetchProblemDetailsRef = useRef(() => Promise.resolve());

  // Generated by GitHub Copilot - Story 08: Simplified Auto-Save Hook (PATCH only)
  const {
    save: autoSave,
    saveNow: autoSaveNow,
    status: autoSaveStatus,
    error: autoSaveError,
    // US2097708 (F1): EVERY field with an unresolved rejection, not just the newest. On a promoted
    // record the 409 refuses every field, so a MIM who edits priority and then message_for_clients
    // has TWO refused edits; rendering only `autoSaveError` would show one and lose the other.
    // Defaulted to [] because tests that mock this hook return the pre-F1 shape with no `errors`.
    errors: autoSaveErrors = [],
    lastSaved: autoSaveLastSaved,
  } = useFieldAutoSave(params.id, {
    // US2028896: keep the cached system-computed peak fresh after every
    // persisted field change. The PATCH response now carries the recomputed
    // peak (audit trail + current priority), so an in-session priority change
    // (e.g. EP4→EP3→EP2→EP1→EP4) is reflected here immediately — the resolve
    // confirmation modal then always presents the true current peak, not the
    // stale page-load value. Only update when the backend actually returned a
    // recognized EP so a field save that omits it can't blank the cached peak.
    onSuccess: (result) => {
      if (result && result.computedPeakPriority) {
        setComputedPeakPriority(result.computedPeakPriority);
      }
    },
    onSaved: async (fieldPath) => {
      // US2092239: clear ONLY this field's failure message. Matching on
      // "status" OR "incident_end" is too wide now that the two writes are
      // independent: a rejected Status→Resolve is not rolled back, so the
      // dropdown still reads "Resolve" while the server holds the prior status,
      // and this message is the ONLY signal the resolve did not persist. If the
      // MIM then sets Impact End and THAT succeeds, a status-scoped warning
      // cleared by an incident_end success leaves the form showing Status =
      // Resolve, no error, and an unresolved server record — exactly the
      // silently-unresolved state this story exists to remove.
      //
      // Deleting per fieldPath (rather than emptying the banner) is what keeps
      // that guarantee when BOTH fields are failed: the surviving message stays
      // on screen and the banner only disappears once the map is empty.
      if (fieldSaveErrorsRef.current.delete(fieldPath)) {
        syncFieldSaveError();
      }
      // US2092239 (Finding 6): the status write landed, so the server and
      // outage.status agree again and outage.status alone is a truthful basis for
      // the gate. Leaving the override armed here would prompt for confirmation
      // on a status change that needs no confirmation — the mirror of the bug it
      // fixes. Covers the resolve that finally persisted AND any plain status
      // write that succeeded after a rejected resolve.
      if (fieldPath === "status") {
        resolveAttemptRef.current = null;
        rejectedResolveRef.current = null;
      }
      // When impacted_applications is saved, fetch updated problem and resolve commanders
      if (fieldPath === "impacted_applications") {
        try {
          const response = await authFetch(problemURL);
          const updatedProblem = await response.json();
          const commanderData = updatedProblem.problem.outages[params.outage];
          const commanders = extractCommanderList(commanderData);
          resolveIncidentCommanders(commanders);
        } catch (error) {
          console.error("Error fetching updated commanders:", error);
        }
      }
      // US1989003 AC3: impacted_applications also drives the Commander + Leadership workflow
      // sections. Refresh the consolidated workflow list independently of the commander fetch
      // above — a failed commander resolve must NOT block the workflow refresh.
      if (fieldPath === "impacted_applications") {
        setWorkflowsChangedSinceLoad(true);
        setWorkflowsRefreshing(true);
        try { await updateConsolidatedWorkflows(); } catch (e) { /* handled inside */ }
      }
      // US1989003 AC3: affected_brands drives the Business Liaison workflow section.
      if (fieldPath === "affected_brands") {
        setWorkflowsChangedSinceLoad(true);
        setWorkflowsRefreshing(true);
        try { await updateConsolidatedWorkflows(); } catch (e) { /* handled inside */ }
      }
      // US1989003: when priority saves, fetch fresh workflows (PATCH must confirm before GET
      // so backend reads the updated priority from S3)
      if (fieldPath === "priority") {
        try {
          // US1989003: ensure spinner is visible for this GET even if the tab-open GET
          // already cleared workflowsRefreshing before the PATCH confirmed
          setWorkflowsRefreshing(true);
          await updateConsolidatedWorkflows();
        } catch (error) {
          console.error("Error refreshing workflows after priority save:", error);
        }
      }
    },
    onError: (err, fieldPath) => {
      // US1989003: PATCH failed all retries — reset the refresh guard so Run re-enables
      setWorkflowsRefreshing(false);
      // US2097708: the hook's error is deliberately NOT copied into local state for the HEADLINE
      // autosave alert. useFieldAutoSave has already recorded it under this field path -- the
      // terminal-failure branch of executeSave runs setFieldErrors(withFieldError(current,
      // fieldPath, err)) immediately before it calls onError -- so that alert renders straight off
      // autoSaveStatus/autoSaveError with no copy to keep in step. That entry does NOT self-clear:
      // it is removed ONLY by its own field path's next save(), next attempt, or success
      // (withoutFieldError is always called with a single fieldPath); a different field saving or
      // succeeding leaves it standing, and `status` is derived so any unresolved failure outranks
      // saving/saved/idle. A local copy of THAT would be a second, unclearable source of truth
      // for a value which is already sticky.
      //
      // What follows is a DIFFERENT surface, not a copy of that one. The US2092239 Status /
      // Impact End projection below is keyed by fieldPath in fieldSaveErrorsRef and IS cleared by
      // its own field's next successful save (see onSaved) and by a refresh whose data postdates
      // the failure, so it is not the unclearable copy the paragraph above rules out. It earns its
      // keep because the headline alert renders the server's own wording, which cannot carry the
      // code-specific "what to do next" instruction FIELD_SAVE_ERROR_MESSAGES supplies for a
      // refused resolve. Every field other than status/incident_end returns before reaching it.

      // US2092239: report a failed Status or Impact End save in terms the MIM can
      // act on, branching on the api-standard error code rather than the prose.
      //
      // The optimistic local write is deliberately NOT reverted. Every other
      // field in this form is optimistic-write-with-no-revert, and a revert
      // fights the shared single-slot debounce in useFieldAutoSave (a second
      // write inside the 1000ms window replaces the first, so a snapshot taken
      // for the dropped write has no save to be reverted by). The 4xx no-retry
      // branch means this message appears immediately instead of after a silent
      // retry storm, so the MIM sees the true persisted state on the next load.
      //
      // US2097708 amends the parenthetical above: the debounce is no longer a single shared slot,
      // it is keyed by fieldPath, so a second write to a DIFFERENT field no longer discards the
      // first. The conclusion is unchanged -- the optimistic write is still not reverted, because
      // every other field in this form behaves the same way -- but do not cite the shared-slot
      // mechanism as the reason for it; that mechanism no longer exists.
      if (fieldPath !== "status" && fieldPath !== "incident_end") return;

      // US2092239 (Finding 6): re-arm the resolve confirmation gate. The two
      // conditions are both load-bearing. `fieldPath === "status"` keeps an
      // Impact End failure (or any other field's failure — already excluded
      // above) from arming it. `resolveAttemptRef.current` narrows "a status
      // write failed" to "a RESOLVE was rejected": it is populated only by
      // persistStatusResolve, so a failed plain status write (e.g. Monitoring)
      // leaves it null and cannot arm the gate with a pre-resolve status that no
      // longer describes what the dropdown shows.
      if (fieldPath === "status" && resolveAttemptRef.current) {
        rejectedResolveRef.current = {
          prevStatus: resolveAttemptRef.current.prevStatus,
        };
      }

      // US2092239: record the message AGAINST its field so only that field's
      // own successful save can clear it (see onSaved above). Keyed, not
      // single-slot: Status and Impact End can be failed simultaneously, and
      // overwriting one with the other loses the guarantee above.
      fieldSaveErrorsRef.current.set(
        fieldPath,
        deriveFieldSaveErrorMessage(err, fieldPath),
      );
      // US2092239 (Finding 1): bump BEFORE the projection so an in-flight
      // fetchProblemDetails that lands next sees a changed sequence and leaves
      // this message alone (its data predates this failure).
      fieldSaveErrorSeqRef.current += 1;
      syncFieldSaveError();
    },
    // US2077763: the save was rejected with a 409 version conflict — another user
    // updated this incident after it was loaded here. Re-fetch the current problem so
    // the view reconciles to the winning server state, then surface a clear, dismissible
    // notice. We deliberately do NOT re-apply the user's edit: re-saving the same field
    // would just conflict again (a save→conflict→save loop). The user sees the latest
    // values and can re-make their change against them if still needed.
    onConflict: () => {
      setWorkflowsRefreshing(false);
      Promise.resolve(fetchProblemDetailsRef.current())
        .catch((err) =>
          console.warn("[ProblemForm] refetch after version conflict failed:", err),
        )
        .finally(() =>
          setConflictNotice(
            "This incident was updated by someone else. It has been reloaded to the latest version — please review and re-apply your change if it's still needed.",
          ),
        );
    },
  });

  // US2097708 + US2092239 (merge collapse): ONE refused-save banner, not two.
  //
  // This branch and main independently added an error Alert to this same content column —
  // ours off the hook's per-field `errors`, main's off fieldSaveErrorsRef — in different
  // JSX positions, so they auto-merged with NO conflict marker and every rejected Status
  // or Impact End save reported the same failure twice in two different wordings.
  //
  // main's surface survives (data-testid="field-save-error"): its record is keyed per
  // field path, is cleared ONLY by that field's own successful save, and is guarded
  // against a stale in-flight fetchProblemDetails by fieldSaveErrorSeqRef.
  //
  // It is FED from both, because dropping ours' input would not have been a de-dup, it
  // would have been a silencing: onError returns early for every fieldPath other than
  // "status"/"incident_end" (see above), so fieldSaveErrorsRef reports NOTHING for the
  // other ~18 autosaved fields — including the 409 promoted_record_write_refused this
  // story exists for, which refuses every field in turn. The hook's own errors supply
  // that reach; main's supply the actionable instruction. Derived, not state.
  const refusedFieldSaves = collectRefusedFieldSaves({
    autoSaveStatus,
    autoSaveError,
    autoSaveErrors,
    fieldSaveErrors,
  });

  // US2097708 (N5): the entry the banner headlines. `autoSaveError` is the hook's NEWEST
  // unresolved failure — what the operator just did — and the de-dup above guarantees a
  // matching entry exists whenever it is set, so this find cannot miss. With no hook
  // error (a Status/Impact End rejection recorded only by main's mechanism) the
  // first-recorded failure leads instead.
  const headlineFieldSave =
    (autoSaveStatus === "error" && autoSaveError
      ? refusedFieldSaves.find(
          (entry) =>
            entry.fieldPath === refusedFieldSaveKey(autoSaveError.fieldPath),
        )
      : null) || refusedFieldSaves[0];

  // US2097708 (N5): name the field in the headline. A sticky failure can sit on screen
  // indefinitely — a 500 on Workaround that exhausts its retries pins "Save failed: PATCH
  // failed (500)" until that field is touched again — and an operator cannot re-enter what
  // the banner will not name. null whenever no label can be derived (missing/blank
  // fieldPath), which the banner treats as "render exactly as it did before".
  const headlineLabel = autoSaveFieldLabel(headlineFieldSave?.fieldPath);

  const [
    requiredCommunicationFieldsMissing,
    setRequiredCommunicationFieldsMissing,
  ] = useState(true);

  const [showFields, setShowFields] = useState({
    messageForClients: false,
    workaround: false,
    numberOfContacts: false,
    salesForceCase: false,
    technicalStatus: false,
    perceivedCause: false,
    currentApproach: false,
    clientImpact: false,
    timeStamps: false,
    reportedIssue: true,
  });

  const [requiredCompositionFields, setRequiredCompositionFields] = useState({
    applications: { label: "Impacted Applications", required: true },
    brands: { label: "Impacted Brands", required: true },
    incidentEnd: { label: "Incident End", required: false },
  });

  const [requiredFieldsMarkup, setRequiredFieldsMarkup] = useState("");

  // react-select doesn't forward arbitrary props to its DOM, so testId is
  // consumed here and rendered on a wrapping div instead. This SimpleMenu is
  // local to ProblemForm — the unrelated shared components/SimpleMenu/index.js
  // has no testId prop; callers of that one wrap externally instead (see
  // StatusPageSelector.js).
  // US2092239: `value` is forwarded so an individual call site can opt into a
  // CONTROLLED select. react-select's useStateManager treats `value === undefined`
  // as uncontrolled and honours `defaultValue`, so the call sites that pass only
  // `defaultValue` are byte-for-byte unaffected. The Status select opts in; see
  // the comment on handleResolvePeakCancel for why.
  //
  // DO NOT HOIST THIS TO MODULE SCOPE. That was tried and reverted: it broke 7
  // of 62 e2e checks (QC-02, QC-08, QC-09, QC-10, QC-12, QC-13, QC-14).
  //
  // Of the SEVEN `SimpleMenu` call sites in this file, only ONE (`status-select`)
  // passes `value`. The other six pass `defaultValue` only, and react-select
  // treats a `value === undefined` select as UNCONTROLLED: it reads
  // `defaultValue` once per mount and ignores every later change to it. Those
  // six therefore depend on this declaration living inside the component body.
  // A component declared in a render body gets a new function identity every
  // render, which React reads as a new component *type*, so it remounts the
  // `<Select>` subtree — and that remount is the only thing that makes the six
  // uncontrolled selects re-read their changed `defaultValue`.
  //
  // Hoisting stops the remount, and those six silently stop reflecting state
  // changes. Concrete casualties: `priority-select` no longer shows a newly set
  // EP priority, and `impacted-applications-select` no longer shows newly set
  // impacted applications. No error is thrown and nothing logs.
  //
  // The Jest suite stays entirely GREEN through that breakage, so a green
  // `npm test` cannot be used to clear a hoist. Only the e2e suite catches it.
  //
  // The remount churn IS a real, still-unfixed bug — it detaches an open menu's
  // option nodes mid-click (see docs/LORE.md) — but the order of operations is
  // not negotiable: migrate ALL SEVEN call sites to a controlled `value` FIRST
  // and prove it in e2e, and only THEN hoist. Hoisting first breaks the six
  // uncontrolled selects, which is exactly the regression that was reverted.
  const SimpleMenu = (props) => (
    <div data-testid={props.testId}>
      <Select
        classNamePrefix="rs"
        isMulti={props.multiple}
        onChange={props.onChange}
        options={props.options}
        defaultValue={props.defaultValue}
        value={props.value}
      ></Select>
    </div>
  );

  const isStandardCommander = (commanderOption) => {
    let i = defaultCommanders.length;
    while (i--) {
      if (defaultCommanders[i].value === commanderOption.value) return true;
    }

    return false;
  };

  // Generated by GitHub Copilot - Story 08: Simplified auto-save wrapper
  // Triggers PATCH for key collaborative fields with a 1000ms debounce. The call to
  // useFieldAutoSave above passes no `debounceMs`, so the delay is that hook's own
  // `debounceMs = 1000` default — earlier comments here claimed 500ms, which was never the
  // value this component gets.
  const handleFieldChangeWithAutoSave = (
    fieldPath,
    newValue,
    oldValue,
    extraFields = null,
  ) => {
    // Trigger auto-save (debounced 1000ms by useFieldAutoSave -- its default)
    // US2028896: extraFields carries confirmedPeakPriority on the resolve PATCH.
    autoSave(fieldPath, newValue, oldValue, extraFields);
  };

  // US2092239: same contract as handleFieldChangeWithAutoSave but bypasses the
  // debounce. `autoSave` shares ONE debounce timer and ONE pending-payload slot
  // across every field, so a second `autoSave` inside the 1000ms window
  // overwrites the first and the first write is never sent — no request, no
  // onError, nothing.
  //
  // That collides head-on with the decoupled resolve flow this story
  // introduces: confirming the peak modal queues the status PATCH, and setting
  // Impact End within the next second discards it. The server would stay
  // unresolved while the dropdown reads "Resolve" and no error surfaces.
  // Confirming a modal is a deliberate one-time commit, not keystroke noise, so
  // it goes out immediately. `saveNow` does not disturb the debounce, so a
  // pending Impact End write still lands (both orderings complete).
  const handleFieldChangeWithImmediateSave = (
    fieldPath,
    newValue,
    oldValue,
    extraFields = null,
  ) => {
    autoSaveNow(fieldPath, newValue, oldValue, extraFields);
  };

  const updateProblem = useCallback(
    (event) => {
      const fieldId = event.target.id;
      const newValue = event.target.value;
      let oldValue;

      // Use functional updater to avoid stale closures and race conditions
      setOutage((prevOutage) => {
        oldValue = prevOutage[fieldId];

        // Create new outage object (no mutations)
        return {
          ...prevOutage,
          [fieldId]: newValue,
        };
      });

      // Update problem state with functional updater
      setProblem((prevProblem) => {
        const prevOutageInProblem = prevProblem.outages?.[outageNumber];
        if (!prevOutageInProblem) return prevProblem;

        // Create new objects (no mutations)
        const updatedOutage = {
          ...prevOutageInProblem,
          [fieldId]: newValue,
        };

        const updatedOutages = {
          ...prevProblem.outages,
          [outageNumber]: updatedOutage,
        };

        return {
          ...prevProblem,
          outages: updatedOutages,
        };
      });

      setSaved(false);

      // Generated by GitHub Copilot - Story 08: Auto-save for key collaborative fields
      // Using simplified field paths (no "outages.OUTAGE 1." prefix) since there's only one outage
      // Phase 1: short_description, description, impact, workaround
      // Phase 2: priority, status, commander, slack_channel, problem-level title/description
      // Additional text fields: mim, businessLiaison, messageForClients, technicalStatus, perceivedCause, currentApproach, vendorTicket
      // More fields: numberOfContacts, salesForceCase, awsAccount, awscase, attendees, pagerDutyID
      const autoSaveFields = [
        "short_description",
        "description",
        "impact",
        "workaround",
        "priority",
        "status",
        "incidentCommander",
        "slackChannel",
        "mim",
        "businessLiaison",
        "messageForClients",
        "technicalStatus",
        "perceivedCause",
        "currentApproach",
        "vendorTicket",
        "numberOfContacts",
        "salesForceCase",
        "awsAccount",
        "awscase",
        "attendees",
        // US2080752: pagerDutyID is intentionally NOT auto-saved here. It owns
        // an explicit save (savePagerDutyIncident, fired on paste/blur/Enter) so
        // it can read Feature 1's validation response; routing it through the
        // shared debounced autosave would fire a duplicate PATCH.
        "PIRContact",
      ];
      if (autoSaveFields.includes(fieldId)) {
        // Map frontend field names to backend field names
        let backendFieldName = fieldId;
        if (fieldId === "incidentCommander") backendFieldName = "commander";
        if (fieldId === "slackChannel") backendFieldName = "slack_channel";
        if (fieldId === "businessLiaison")
          backendFieldName = "business_liaison";
        if (fieldId === "messageForClients")
          backendFieldName = "message_for_clients";
        if (fieldId === "technicalStatus")
          backendFieldName = "technical_status";
        if (fieldId === "perceivedCause") backendFieldName = "perceived_cause";
        if (fieldId === "currentApproach")
          backendFieldName = "current_approach";
        if (fieldId === "vendorTicket") backendFieldName = "vendor_ticket";
        if (fieldId === "numberOfContacts")
          backendFieldName = "number_of_contacts";
        if (fieldId === "salesForceCase") backendFieldName = "salesforce_case";
        if (fieldId === "awsAccount") backendFieldName = "aws_account";
        if (fieldId === "awscase") backendFieldName = "aws_case";
        // Generated by GitHub Copilot - PIR Contact auto-save support
        if (fieldId === "PIRContact") backendFieldName = "pir_contact";

        handleFieldChangeWithAutoSave(backendFieldName, newValue, oldValue);
      }
    },
    [outageNumber, handleFieldChangeWithAutoSave],
  );

  // US2080752: scoped, explicit save/validate for the PagerDuty Incident ID.
  // Fired on paste, blur, and Enter (see the field's handlers) so a MIM can
  // copy-paste an incident ID and have it save/validate WITHOUT pressing Enter.
  // It is NOT fired on every keystroke (onChange stays local-only) because each
  // fire is a LIVE PagerDuty existence API call.
  //
  // The shared debounced autosave (useFieldAutoSave) cannot deliver Feature 1's
  // response to THIS field. On failure it keeps only the server's `message` and
  // `error` code off the body (callPatchEndpoint) and discards the rest. On
  // success it does hand the whole parsed body to `onSuccess(result)`, but with
  // no field path attached -- one shared callback serves every autosaved field,
  // and the only callback that names the field, `onSaved(fieldPath, timestamp)`,
  // gets no body. So this field does its OWN awaited PATCH to read Feature 1's
  // response and surface it inline. This does NOT touch the shared autosave used
  // by every other field.
  //
  //   - 400 { message } (incident not found) → RED inline error; input stays
  //     visible so the user can correct it; do NOT flip to the PageLeadership view.
  //   - 200 { warning } (fail-open, couldn't confirm) → AMBER inline warning AND
  //     flip to the PageLeadership view (the value was saved).
  //   - 200 (confirmed) → clear any message and flip to the PageLeadership view.
  const savePagerDutyIncident = useCallback(
    async (rawValue) => {
      const value = (rawValue ?? "").trim();

      // US2080752: nothing to validate — matches the prior on-Enter behavior of
      // never PATCHing an empty/whitespace value (also covers empty→empty blur).
      if (!value) return;

      // US2080752 dedupe: the broadened triggers (paste, blur, Enter) can fire
      // for the same value more than once (paste then blur, repeated blurs,
      // blur after Enter). Early-return with NO network call when the value has
      // not changed since the last save was initiated, so a paste doesn't
      // hammer the live PagerDuty existence check. Claim the value synchronously
      // (before any await) so two near-simultaneous fires can't both get through.
      if (value === pagerDutyLastSubmittedRef.current) return;
      pagerDutyLastSubmittedRef.current = value;

      // US2080752 in-flight guard: claim the latest request id for this save.
      // Only the response matching this id may commit state/message, so an
      // earlier (stale) save that resolves after a newer one can never clobber
      // it. Reading pagerDutySaveSeqRef.current at commit time is the "latest
      // wins" check.
      const requestSeq = pagerDutySaveSeqRef.current + 1;
      pagerDutySaveSeqRef.current = requestSeq;
      const isLatest = () => pagerDutySaveSeqRef.current === requestSeq;

      // Clear any prior inline message before re-attempting.
      setPagerDutyFieldMessage(null);

      // US2080752: keep local form/problem state in sync with what we are
      // persisting WITHOUT routing through updateProblem. updateProblem treats
      // pagerDutyID as an autosave field and would fire a SECOND (debounced,
      // raw-fetch) PATCH ~1s later, so this field owns its single explicit
      // authFetch PATCH below. We mutate local display state directly instead.
      //
      // Commit local state ONLY on a successful (2xx) save. Mutating outage/
      // problem optimistically before the response left a rejected (400) or
      // failed (transport/401) value sitting in state with nothing to roll
      // back; on those paths we now set the inline message only and leave the
      // prior committed value untouched.
      const commitLocalPagerDutyID = (committedValue) => {
        setOutage((prevOutage) => ({
          ...prevOutage,
          pagerDutyID: committedValue,
        }));
        setProblem((prevProblem) => {
          const prevOutageInProblem = prevProblem.outages?.[outageNumber];
          if (!prevOutageInProblem) return prevProblem;
          return {
            ...prevProblem,
            outages: {
              ...prevProblem.outages,
              [outageNumber]: {
                ...prevOutageInProblem,
                pagerDutyID: committedValue,
              },
            },
          };
        });
        setSaved(false);
      };

      try {
        const response = await authFetch(
          `${apiBase}problem/${params.id}/field`,
          {
            method: "PATCH",
            body: JSON.stringify({ fieldPath: "pagerduty_id", value }),
          },
        );

        // A newer Enter superseded this one while it was in flight — drop this
        // (stale) response without touching state or the inline message.
        if (!isLatest()) return;

        let body = {};
        try {
          body = await response.json();
        } catch (parseErr) {
          body = {};
        }

        if (!isLatest()) return;

        if (!response.ok) {
          // US2077763 (PR #631): this path does its own PATCH and bypasses the
          // useFieldAutoSave 409 handler. A CAS version conflict here must reconcile the same
          // way (re-fetch the winning state + show the dismissible notice) — otherwise the
          // nested {error:{code,message}} 409 body has no top-level `message`, so the operator
          // just sees a generic failure sitting on stale data. Mirrors the onConflict handler.
          if (response.status === 409) {
            setWorkflowsRefreshing(false);
            Promise.resolve(fetchProblemDetailsRef.current())
              .catch((e) =>
                console.warn(
                  "[ProblemForm] refetch after PagerDuty-save version conflict failed:",
                  e,
                ),
              )
              .finally(() =>
                setConflictNotice(
                  "This incident was updated by someone else. It has been reloaded to the latest version — please review and re-apply your change if it's still needed.",
                ),
              );
            return;
          }
          // Feature 1: 400 not-found → red inline error; keep input visible.
          // Nothing was committed optimistically, so there is nothing to roll
          // back and the prior committed value is untouched.
          setPagerDutyFieldMessage({
            variant: "error",
            text:
              (body && body.message) ||
              "Could not save the PagerDuty incident.",
          });
          return;
        }

        // Feature 1 fail-open warning → amber inline warning (still saved).
        if (body && body.warning) {
          setPagerDutyFieldMessage({ variant: "warning", text: body.warning });
        }

        // US2080752: the backend normalizes a pasted full URL / display id into
        // a bare incident id (stored on the outage). Commit THAT value so the
        // PageLeadership timeline link (.../incidents/<bareID>/timeline) is
        // correct without a reload; fall back to the entered value if absent.
        // This is the ONLY place local state is committed — success only.
        const committedValue = (body && body.normalizedValue) || value;
        commitLocalPagerDutyID(committedValue);
        setEnteredPagerDutyIncident(committedValue);

        // Flip to the PageLeadership view ONLY on a successful save.
        setpagerDutyIncident(committedValue);
      } catch (err) {
        // authFetch throws on 401 (handled globally) or transport error — keep
        // the input visible with a red error so a rejected value is not treated
        // as committed. Nothing was committed optimistically, so there is
        // nothing to roll back.
        if (!isLatest()) return;
        setPagerDutyFieldMessage({
          variant: "error",
          text: "Could not save the PagerDuty incident. Please try again.",
        });
      }
    },
    [apiBase, params.id, outageNumber],
  );

  let navigate = useNavigate();

  const fetchProblemDetails = useCallback(() => {
    // US2080752 (PR #623 review): snapshot the PD save sequence at the moment
    // this refresh starts. Used below to avoid clearing a fail-open warning that
    // an Enter-save set while this (async) refresh was in flight.
    const seqAtRefreshStart = pagerDutySaveSeqRef.current;
    // US2092239 (Finding 1): same snapshot, for the field-save-error banner.
    const fieldSaveErrorSeqAtRefreshStart = fieldSaveErrorSeqRef.current;
    return fetch(problemURL)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        setLoaded(true);
      })
      .catch((error) => {
        console.error("[ProblemForm] Fetch error:", error);
      })
      .then(
        (result) => {
          if (!result.problem) {
            alert("no problem?");
            return;
          }
          const prb = result.problem;

          // US2028896: capture the system-computed peak for the resolve modal.
          setComputedPeakPriority(result.computedPeakPriority || "");

          setArchived(prb.archived);
          setCommunications(prb.communications);

          // US2097708: forward the EDIT page off a promoted-away PRBT URL. Shares the
          // Viewer's forward predicate (utils/incidentLinkage.js
          // shouldForwardToPermanent, D3) so the two can never diverge — the conversion
          // never clears `temporary` on the outgoing record, so a promoted-away PRBT is
          // persisted with temporary:true AND permanentNumber set. Without this, opening a
          // dead PRBT edit URL from a bookmark, a Slack link, browser history or a
          // stranded tab renders the archived record and every autosave 409s: a dead end.
          //
          // Read from `prb` (server truth), never from `problem` state — that state is
          // locally mutated on every keystroke by onNumberChange and by the AC3 branch,
          // and US2085183 depends on that optimistic window.
          //
          // Bare target, no outage segment: /problem/edit/:id is a real route
          // (AppWrapper.js, the `<Route path="/problem/edit/:id">` entry), so the
          // permanent record's own load then runs the
          // normalization redirect against ITS outages — correct, because the PRBT's
          // outage ids are not guaranteed to match the permanent record's.
          //
          // The forward must SUPPRESS the normalization redirect below in this same
          // invocation. That redirect runs synchronously in this body, against the
          // already-fetched OLD `prb`, so it would navigate straight back to the dead
          // PRBT and win — defeating the forward on exactly the bare
          // /problem/edit/PRBT… URL (bookmark, Slack link, stranded tab) it exists for.
          // Hence the flag rather than an early return: returning early would strand the
          // spinner, since setLoaded(true) is inside the setTimeout at the end of this
          // handler. Both navigations keep replace:true for the US2009267 reason below.
          const forwardedToPermanent = shouldForwardToPermanent(
            prb.permanentNumber,
            prb,
          );
          if (forwardedToPermanent) {
            navigate(`/problem/edit/${prb.permanentNumber}`, { replace: true });
          }

          if (prb.outages) {
            if (!params.outage && !forwardedToPermanent) {
              const firstOutageID = Object.keys(prb.outages)[0];
              // US2009267: replace (not push) this on-load normalization redirect.
              // A push leaves the bare /problem/edit/:id entry in history; browser
              // Back then lands on it, which re-fires this redirect and traps the
              // user in edit. Replacing it lets Back return to the Modern
              // /problem/view/:id detail the user came from.
              navigate(`/problem/edit/${prb.number}/outage/${firstOutageID}`, {
                replace: true,
              });
            }

            const link = `/problem/view/${prb.number}`;

            setViewLink(link);
            // US2092239 (Finding 6): outage.status is about to be re-hydrated
            // from the server, which is precisely what the "Reload the page"
            // instruction in FIELD_SAVE_ERROR_MESSAGES relies on to re-arm the
            // gate. From here outage.status is truthful on its own, so the
            // override is stale by definition and must not survive the load.
            resolveAttemptRef.current = null;
            rejectedResolveRef.current = null;
            // US2092239 (Finding 1): the failure messages must not outlive the
            // re-hydration either. Every message this banner can carry says some
            // variant of "reload the page to see the saved value" — and this IS
            // that reload: Status (setStatus below) and Impact End
            // (setIncidentEnd below) are both re-read from the server here, so
            // the form now shows the persisted truth and the instruction has
            // already been carried out. fetchProblemDetails is NOT mount-only —
            // sending a communication re-runs it — so leaving the map alone left
            // the MIM staring at an instruction that no longer applied, on the
            // one piece of UI whose whole job is to be trustworthy about
            // persisted state.
            //
            // Guarded on the sequence so this can only clear messages that were
            // already on screen when this refresh STARTED. A Status or Impact
            // End save that failed while the fetch was in flight (the comm-send
            // path waits 2000ms before fetching, and the field debounce is
            // 1000ms plus retries, so the window is reachable) bumped the
            // sequence, and its message describes state this response predates —
            // clearing it would be the same silent-wipe defect in the other
            // direction. It survives to the next refresh instead.
            if (fieldSaveErrorSeqRef.current === fieldSaveErrorSeqAtRefreshStart
              && fieldSaveErrorsRef.current.size > 0) {
              fieldSaveErrorsRef.current.clear();
              syncFieldSaveError();
            }
            setOutage(prb.outages[params.outage]);
            setOutageNumber(params.outage);

            const outagePriority =
              prb.outages[params.outage] && prb.outages[params.outage].priority
                ? prb.outages[params.outage].priority
                : "EP4";

            setPriorityOption({ label: outagePriority, value: outagePriority });

            const affectedUsers =
              prb.outages[params.outage] &&
              prb.outages[params.outage].affectedUsers
                ? prb.outages[params.outage].affectedUsers
                : "";

            setAffectedUserOption({
              label: affectedUsers,
              value: affectedUsers,
            });

            setShowExternalMessage(affectedUsers !== "Internal");

            const outageStatus =
              prb.outages[params.outage] && prb.outages[params.outage].status
                ? prb.outages[params.outage].status
                : "Log / Classify";
            setStatus({ label: outageStatus, value: outageStatus });

            const outageSlackChannel =
              prb.outages[params.outage] &&
              prb.outages[params.outage].slackChannel
                ? prb.outages[params.outage].slackChannel
                : "None";

            setSlack(createOption(outageSlackChannel));
            const currentOutage = prb.outages[params.outage];

            currentOutage &&
            currentOutage.incidentStart &&
            currentOutage.incidentStart !== 0
              ? setIncidentStart(new Date(currentOutage.incidentStart))
              : setIncidentStart();

            currentOutage &&
            currentOutage.incidentEnd &&
            currentOutage.incidentEnd !== 0
              ? setIncidentEnd(new Date(currentOutage.incidentEnd))
              : setIncidentEnd();

            currentOutage &&
            currentOutage.eocNotified &&
            currentOutage.eocNotified !== 0
              ? setEOCNotified(new Date(currentOutage.eocNotified))
              : setEOCNotified();

            currentOutage &&
            currentOutage.timeDetected &&
            currentOutage.timeDetected !== 0
              ? setTimeDetected(new Date(currentOutage.timeDetected))
              : setTimeDetected();

            currentOutage &&
            currentOutage.techTimeResolved &&
            currentOutage.techTimeResolved !== 0
              ? setTechTimeResolved(new Date(currentOutage.techTimeResolved))
              : setTechTimeResolved();

            currentOutage &&
            currentOutage.nextUpdate &&
            currentOutage.nextUpdate !== 0
              ? setNextUpdate(new Date(currentOutage.nextUpdate))
              : setNextUpdate();

            const outageImpactedApplications =
              prb.outages[params.outage] &&
              prb.outages[params.outage].impactedApplications
                ? prb.outages[params.outage].impactedApplications
                : [];

            setImpactedApplications(outageImpactedApplications);
            setStatusApplications(
              formatProductStatus(outageImpactedApplications),
            );
            setStatusApplications(
              formatProductStatus(outageImpactedApplications),
            );

            // Generated by GitHub Copilot
            // Use the new defaultCommanders field from delivery stream resolution
            // Fall back to legacy commanderOptions for backward compatibility
            const commanderData = prb.outages[params.outage];
            const commanderList = extractCommanderList(commanderData);
            const defaultCommanderOptions = commanderList.map((o) =>
              createOption(o),
            );

            setDefaultCommanders(defaultCommanderOptions);
            let commanderOptions = defaultCommanderOptions;
            if (
              prb.outages[params.outage] &&
              prb.outages[params.outage].commanderOverride
            ) {
              setCommanderOverride(
                prb.outages[params.outage].commanderOverride,
              );

              const newOption = createOption(
                prb.outages[params.outage].incidentCommander,
              );

              const standardCommander = isStandardCommander(newOption);

              if (standardCommander) {
                setCommanderOverride(false);
              }
              if (!standardCommander) {
                commanderOptions = [...commanderOptions, newOption];
              }
            }

            setCommanderOptions(commanderOptions);

            const currentIncidentCommander =
              prb.outages[params.outage] &&
              prb.outages[params.outage].incidentCommander
                ? createOption(prb.outages[params.outage].incidentCommander)
                : { label: "None", value: "None" };

            setIncidentCommander(currentIncidentCommander);

            if (prb && prb.number && prb.number.startsWith("PRBT")) {
              setNumberEditable(true);
            }

            if (
              prb.outages[params.outage] &&
              prb.outages[params.outage].pagerDutyID
            ) {
              setpagerDutyIncident(prb.outages[params.outage].pagerDutyID);
              // US2080752 (PR #623 review): the stored PD is confirmed non-empty
              // on this refresh, so clear a lingering fail-open amber warning
              // ("couldn't confirm") instead of letting it persist forever.
              // Guarded so it only ever clears the WARNING variant — never a red
              // error the user is mid-editing — and only when no newer Enter-save
              // started while this refresh was in flight (reusing the existing
              // pagerDutySaveSeqRef guard), so it can't wipe a message the save
              // just set in the same tick.
              if (pagerDutySaveSeqRef.current === seqAtRefreshStart) {
                setPagerDutyFieldMessage((prev) =>
                  prev && prev.variant === "warning" ? null : prev,
                );
              }
            }

            const affectedBrands =
              prb.outages[params.outage] &&
              prb.outages[params.outage].affectedBrandCapability &&
              prb.outages[params.outage].affectedBrandCapability.map((m) => {
                return m;
              });

            if (affectedBrands) {
              setAffectedBrands(affectedBrands);
            }

            if (prb.communications && prb.communications.length > 0) {
              const lastCommunication =
                prb.communications[prb.communications.length - 1];
              setPublishingTargets(lastCommunication.statusPageRoutes);
            }
          } // end if (prb.outages)

          // US2138216: a refetch (409 conflict, PagerDuty, version restore,
          // comms send) keeps an unsaved PRBT number while the server still
          // has that PRBT. Dropping it would end the unsaved-number prompt
          // with no warning and leave the MIM working the PRBT.
          const numberDraft = unsavedNumberDraftRef.current;
          const keepNumberDraft = numberDraft !== null && prb.number === numberDraft.original;
          setProblem(keepNumberDraft ? { ...prb, number: numberDraft.value } : prb);

          // Generated by GitHub Copilot - Capture original problem number for save comparison
          if (prb.number && !keepNumberDraft) {
            setOriginalNumber(prb.number);
            setNumberModified(false);
            setNumberSaveStatus("idle");
            // US2097708 (A6): clear the message as well, symmetric with
            // onNumberChange. Nothing renders on status alone (the inline error
            // requires both), but a stale message left in state is exactly the
            // trap of a wrong explanation surviving into a later attempt.
            setNumberSaveError("");
          }

          // Generated by GitHub Copilot
          // Capture current version for version validation
          if (prb.currentVersion) {
            setCurrentVersion(prb.currentVersion);
          }

          // Generated by GitHub Copilot
          // Removed deprecated workflow loading logic - workflows now come from consolidated backend data
          // Legacy commanderPolicyOptions and leadershipWorkflowOptions fields no longer exist

          setTimeout(() => {
            setLoaded(true);
          }, 1500);
        },
        (error) => {
          console.error("[ProblemForm] Problem fetch error:", error);
        },
      )
      .catch((error) => {
        console.error("[ProblemForm] Problem fetch error:", error);
      });
  }, [params, navigate, problemURL]);

  // US2077763: keep the forward-reference ref pointed at the latest fetchProblemDetails
  // so the useFieldAutoSave onConflict handler (declared earlier) always calls the
  // current closure — never a stale one — when it re-fetches after a 409 conflict.
  fetchProblemDetailsRef.current = fetchProblemDetails;

  const handleVersionRestore = useCallback(
    (versionId) => {
      // Refresh problem data after version restoration
      setLoaded(false);
      fetchProblemDetails().then(() => {
        setLoaded(true);
      });
    },
    [fetchProblemDetails],
  );

  // Generated by GitHub Copilot
  const handleVersionCountChange = useCallback((count) => {
    setVersionCount(count);
  }, []);

  // Generated by GitHub Copilot
  // Callback handler to receive unexecuted workflow count from PageLeadership component
  const handleUnexecutedWorkflowCountChange = useCallback((count) => {
    setUnexecutedWorkflowCount(count);
  }, []);

  // Generated by GitHub Copilot
  // This function is no longer needed since configuration is loaded centrally in App.js
  // Keep as placeholder for backward compatibility but no longer fetch data
  const fetchProductOptions = useCallback(
    async (maxRetries = 3) => {
      // No-op - configuration is now handled centrally in App.js
    },
    [configuration],
  );

  // Generated by GitHub Copilot
  // This function is no longer needed since configuration is loaded centrally in App.js
  const fetchConfiguration = useCallback(() => {
    // No-op - configuration is now handled centrally in App.js
    // Set slack channels from centralized configuration
    if (configuration.slack && configuration.slack.channels) {
      setSlackChannels(configuration.slack.channels);
    }

    // No longer fetch configuration - it's passed as prop
    return Promise.resolve();
  }, [configuration]);

  // Generated by GitHub Copilot
  // Updated to use centralized configuration
  useEffect(() => {
    setLoaded(false);

    // Initialize slack channels from centralized configuration
    if (configuration.slack && configuration.slack.channels) {
      setSlackChannels(configuration.slack.channels);
    }

    // Fetch all initial data in parallel
    // fetchProblemDetails never rejects, so this marks the problem itself as
    // loaded even when a sibling fetch fails first.
    const problemLoaded = fetchProblemDetails();
    const fetchInitialData = async () => {
      try {
        const [problemData, groups, templates, brandsResult] = await Promise.all([
          problemLoaded,
          ComponentAPI.getGroups(),
          TemplateAPI.get(params.id),
          BrandsAPI.get(),
        ]);

        // Process groups for StatusPage Selector
        const groupOptions =
          groups &&
          groups.map((g) => {
            return { label: g.name, value: g.id };
          });

        // US1929214: Brand dropdown now sourced from BrandsAPI instead of StatusPage groups
        const brands = (brandsResult && brandsResult.brands) || [];
        setBrandOptions(brands.map((b) => ({ label: b.name, value: b.id })));
        setGroupOptions(groupOptions);

        // Process templates
        const options = Object.keys(templates).map((t) => {
          return {
            label: templates[t].name,
            value: templates[t].name,
            type: t,
            priority: templates[t].priority,
          };
        });

        options.sort((a, b) => {
          const lessthan = a.priority < b.priority ? -1 : 1;
          return lessthan;
        });
        setTemplateOptions(options);
      } catch (error) {
        console.error("[ProblemForm] Error fetching initial data:", error);
      } finally {
        await problemLoaded;
        setInitialLoadSettled(true);
      }
    };

    fetchInitialData();
  }, [params, configuration]);

  // US1873550: Fetch current reported impacts. Called on mount (via useEffect) and
  // explicitly on comms tab switch so the snapshot is never stale at send time.
  const problemNumber = problem?.number;
  const impactsFetchControllerRef = useRef(null);
  const fetchReportedImpacts = useCallback(() => {
    if (!problemNumber) return;
    // Abort any in-flight request before starting a new one.
    impactsFetchControllerRef.current?.abort();
    const controller = new AbortController();
    impactsFetchControllerRef.current = controller;
    setReportedImpactsLoading(true);
    impactService
      .getImpacts(problemNumber, {}, { signal: controller.signal })
      .then((data) => {
        // API returns { count, impacts: [...] }
        const raw = data?.impacts ?? data;
        const list = Array.isArray(raw) ? raw : [];
        const sorted = [...list].sort((a, b) => {
          if (a.status === "active" && b.status !== "active") return -1;
          if (a.status !== "active" && b.status === "active") return 1;
          return 0;
        });
        setReportedImpacts(sorted);
      })
      .catch((err) => {
        if (err?.name === "AbortError") return;
        console.warn("[ProblemForm] Failed to fetch reported impacts:", err);
        setReportedImpacts([]);
      })
      .finally(() => {
        setReportedImpactsLoading(false);
      });
  }, [problemNumber]);
  useEffect(() => {
    fetchReportedImpacts();
    return () => impactsFetchControllerRef.current?.abort();
  }, [fetchReportedImpacts]);

  // Generated by GitHub Copilot
  // Removed useEffect for loading components based on groupOption
  // This is now handled internally by StatusPageSelector component

  // Generated by GitHub Copilot
  // Removed deprecated priority-based workflow generation useEffect
  // Priority workflows (IRE, EP1/EP2 Leader P2B) are now generated in backend

  useEffect(() => {
    let missingCriteria = [];

    const properPriority =
      priorityOption.value === "EP1" || priorityOption.value === "EP2";

    properPriority || missingCriteria.push("EP1 or EP2 priority required");

    const impactedApplications =
      outage &&
      outage.impactedApplications &&
      outage.impactedApplications.length > 0;

    const affectedBrands =
      outage &&
      outage.affectedBrandCapability &&
      outage.affectedBrandCapability.length > 0;

    impactedApplications ||
      missingCriteria.push(
        "Select Impacted Applications, Products or Services",
      );

    // Generated by GitHub Copilot
    // US1515936: Check for network-only selection which is too vague for leadership paging
    const hasNetworkOnlySelection =
      impactedApplications &&
      outage.impactedApplications.length === 1 &&
      outage.impactedApplications[0]?.value ===
        "Network (Core, Wan, Campus, Auction)";

    hasNetworkOnlySelection &&
      missingCriteria.push(
        "Network-only selection is too vague - select at least one additional application to target leadership properly",
      );

    affectedBrands || missingCriteria.push("Select an Affected Brand");
    setShowPagingForm(
      properPriority &&
        impactedApplications &&
        !hasNetworkOnlySelection &&
        affectedBrands,
    );

    setMissingPagingCriteria(missingCriteria);
  }, [priorityOption, outage]);

  // Generated by GitHub Copilot
  // Removed deprecated business liaison workflow generation useEffect
  // Business liaison workflows are now generated in backend and included in consolidatedWorkflows

  useEffect(() => {
    const slice =
      affectedBrands &&
      affectedBrands.map((e) => {
        return `${e.label}`;
      });

    let statusString = "";

    switch (slice.length) {
      case 0:
        break;
      case 1:
        statusString = slice[0];
        break;
      default:
        statusString = slice.slice(0, slice.length - 1).join(", ");
        statusString += ` and ${slice[slice.length - 1]}`;
    }

    setStatusBrand(statusString);
  }, [affectedBrands]);

  useEffect(() => {
    requiredCompositionFields["applications"].required = !statusApplications;
    requiredCompositionFields["brands"].required = !statusBrand;

    requiredCompositionFields["incidentEnd"].required =
      templateOption &&
      templateOption.value === "Clear" &&
      outage &&
      outage.incidentEnd === undefined;

    let requiredFieldsMissing = false;

    const markup = Object.keys(requiredCompositionFields).map((e) => {
      requiredFieldsMissing =
        requiredFieldsMissing || requiredCompositionFields[e].required;
      return requiredCompositionFields[e].required ? (
        <p className="requiredField" key={requiredCompositionFields[e].label}>
          {requiredCompositionFields[e].label}
        </p>
      ) : (
        ""
      );
    });

    setRequiredCompositionFields(requiredCompositionFields);
    setRequiredCommunicationFieldsMissing(requiredFieldsMissing);
    setRequiredFieldsMarkup(markup);
  }, [
    statusApplications,
    statusBrand,
    templateOption,
    outage,
  ]);

  const formatProductStatus = (e) => {
    let productStatus = e.length > 0 ? `${e[0].label} ` : "";

    if (e.length > 1) {
      let x = e.map((i) => i);

      let statusPieces = [];
      x.forEach((i) => {
        statusPieces.push(i.label);
      });
      const status = statusPieces.join(", ");
      const lastComma = status.lastIndexOf(",");

      productStatus =
        status.substring(0, lastComma) +
        " and " +
        status.substring(lastComma + 1, status.length) +
        " ";
    }
    return productStatus;
  };

  // watch templateOption
  useEffect(() => {
    let showFields = {};

    if (
      templateOption &&
      [
        "New",
        "Update",
        "Clear",
        "RTS DMV New",
        "DC not a DDoS New",
        "DC Redundant Circuit New",
        "Update - Systems Recovering",
      ].includes(templateOption.value)
    ) {
      showFields = {
        ...showFields,
        workaround: true,
        numberOfContacts: true,
        salesForceCase: true,
        technicalStatus: true,
        perceivedCause: true,
        currentApproach: true,
        severity: true,
        clientImpact: true,
        incidentStart: true,
        incidentEnd: true,
        eocNotified: true,
        timeStamps: true,
        reportedIssue: false,
        vendors: true,
        commander: true,
        mim: true,
      };
    }

    if (templateOption && ["Advisory"].includes(templateOption.value)) {
      showFields.reportedIssue = true;
    }

    setShowFields(showFields);

    // Set showReportedIssue based on Advisory template
    if (templateOption && templateOption.value === "Advisory") {
      setShowReportedIssue(true);
    } else {
      setShowReportedIssue(false);
    }
  }, [templateOption]);

  // Generated by GitHub Copilot
  // Removed addPublishingTarget and removePublishingTarget functions
  // These are now handled internally by StatusPageSelector component

  const saveProblemUpdates = (problem, callback) => {
    // Generated by GitHub Copilot
    // Include current version in the request body for version validation
    const problemWithVersion = {
      ...problem,
      currentVersion: currentVersion,
    };

    let requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(problemWithVersion),
    };

    fetch(problemURL, requestOptions)
      .then((res) => {
        // Generated by GitHub Copilot
        // Version conflicts are now handled permissively by the backend
        // All version conflicts are logged on the backend but updates proceed successfully
        if (res.status > 399) {
          setTimeout(() => {}, 1000);
          throw new Error("HTTP CODE: " + res.status);
        }
        return res;
      })
      .then((response) => response.json())
      .then(
        (data) => {
          if (data.problem) {
            // Generated by GitHub Copilot
            // Update current version after successful save
            if (data.problem.currentVersion) {
              setCurrentVersion(data.problem.currentVersion);
            }
            NewRelic?.addPageAction("Problem.Saved", {
              problemNumber: problem?.number,
            });
            callback(data.problem.id);
          } else {
          }
        },
        (error) => {
          // Generated by GitHub Copilot
          // Handle general save errors (version conflicts are now resolved on backend)
          console.error("Error saving problem:", error.message);
          NewRelic?.noticeError(error);
          NewRelic?.addPageAction("Problem.SaveFailed", {
            errorMessage: error?.message,
            problemNumber: problem?.number,
          });
          alert(
            "There was an error saving the problem. Please try again later.",
          );
        },
      );
  };

  // Generated by GitHub Copilot
  const onStartChange = (date) => {
    if (date) {
      const oldValue = incidentStart ? incidentStart.getTime() : null;
      const newValue = date.getTime();

      setIncidentStart(date);
      let currentOutage = outage;
      currentOutage.incidentStart = newValue;

      setOutage({ ...outage, incidentStart: currentOutage.incidentStart });
      problem.outages[outageNumber] = currentOutage;
      setProblem(problem);
      setSaved(false);

      // Auto-save the date field
      handleFieldChangeWithAutoSave("incident_start", newValue, oldValue);
    }
  };

  // Wraps buildSendCommunicationPayload so the Slack card preview sends the exact body
  // attachCommunication would, rather than a second hand-assembled one that can drift.
  const buildCurrentSendPayload = (sender) =>
    buildSendCommunicationPayload({
      outage,
      priorityOption,
      templateOption,
      incidentCommander,
      reportedIssue,
      slackSmsCommunication,
      nextUpdate,
      incidentStart,
      incidentEnd,
      eocNotified,
      timeDetected,
      techTimeResolved,
      applications: impactedApplications.map((o) => o.label),
      publishingTargets,
      sender,
      // US1873550: Snapshot reported impacts at send time for inclusion in email template.
      reportedImpacts,
    });

  // Generated by GitHub Copilot
  // Updated to use async/await with proper error handling (US1778407)
  const attachCommunication = async () => {
    // Clear any previous errors and stale success alerts
    setSendError(null);
    setPeerReviewSuccess(null);
    // Set loading state
    setIsSendingCommunication(true);

    // Generated by GitHub Copilot
    // Retrieve user data from local storage per US1778248
    // This provides sender information for the communication
    let senderName = "Generic MIM";
    let senderEmail = "coxautomim@coxautoinc.com";
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        senderName = user.name || "";
        senderEmail = user.email || "";
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }

    const communication = buildCurrentSendPayload({
      name: senderName,
      email: senderEmail,
    });

    try {
      // Generated by GitHub Copilot
      // Await the API call for proper error handling (US1778407)
      await CommunicationAPI.attachCommunication(
        problem.number,
        outage.number,
        communication,
      );

      // Success: Close modal and reload page
      try {
        NewRelic?.addPageAction("Communication.Sent", {
          problemNumber: problem?.number,
          outage: outage?.number,
          template_type: templateOption?.type || 'unknown',
          component_ids: (publishingTargets || []).map(t => t?.value ?? t).join(','),
          subject: outage?.short_description || '',
        });
      } catch (nrErr) {
        console.warn('[ProblemForm] Communication.Sent tracking failed:', nrErr);
      }
      setIsSendingCommunication(false);
      setShowPreviewModal(false);

      // Generated by GitHub Copilot
      // Clear template selection after sending communication
      setTemplateOption(null);
      setSlackSmsCommunication("");

      setTimeout(() => {
        fetchProblemDetails().then(() => {
          // Generated by GitHub Copilot
          // Refresh templates after sending communication to update available options
          updateTemplates().catch((err) => console.warn('[ProblemForm] template refresh failed after send:', err));
          // navigate("/problem/edit/" + problem.number + "/outage/OUTAGE%201");
          setTabKey("history"); // not changeTabs — Tab.Loaded must not fire on this programmatic switch
        });
      }, 2000);
    } catch (error) {
      // Generated by GitHub Copilot
      // Error handling with 3-second display then auto-close (US1778407)
      console.error("Failed to send communication:", error);
      try {
        NewRelic?.noticeError(error);
        NewRelic?.addPageAction("Communication.Failed", {
          errorMessage: error?.message,
          problemNumber: problem?.number,
        });
      } catch (nrErr) {
        console.warn('[ProblemForm] Communication.Failed tracking failed:', nrErr);
      }
      setIsSendingCommunication(false);
      setSendError(
        `Failed to send communication. Please try again. ${error.message}`,
      );

      // Display error for 3 seconds, then close modal
      setTimeout(() => {
        setSendError(null);
        setShowPreviewModal(false);
      }, 3000);
    }
  };

  // Generated by GitHub Copilot
  const onDetectedChange = (date) => {
    if (date) {
      const oldValue = timeDetected ? timeDetected.getTime() : null;
      const newValue = date.getTime();

      setTimeDetected(date);
      let currentOutage = outage;
      currentOutage.timeDetected = newValue;

      setOutage({ ...outage, timeDetected: currentOutage.timeDetected });
      problem.outages[outageNumber] = currentOutage;
      setProblem(problem);
      setSaved(false);

      // Auto-save the date field
      handleFieldChangeWithAutoSave("time_detected", newValue, oldValue);
    }
  };

  // Generated by GitHub Copilot
  // US2092239: persist Impact End as a plain, ungated field write. The
  // `confirmedPeak` parameter this helper used to accept (US2028896) is gone
  // along with its only non-null caller: Impact End is no longer a resolve
  // trigger, so there is no peak to freeze here. Keeping the parameter would
  // have been actively unsafe rather than merely vestigial — the backend no
  // longer has an incident_end peak gate, so a revived caller passing a
  // confirmedPeakPriority would have it accepted, unvalidated, and silently
  // discarded.
  const persistIncidentEnd = (date) => {
    const oldValue = incidentEnd ? incidentEnd.getTime() : null;
    const newValue = date.getTime();

    setIncidentEnd(date);

    let currentOutage = outage;
    currentOutage.incidentEnd = newValue;

    setOutage({
      ...outage,
      incidentEnd: currentOutage.incidentEnd,
    });
    problem.outages[outageNumber] = currentOutage;
    setProblem(problem);
    setSaved(false);

    handleFieldChangeWithAutoSave("incident_end", newValue, oldValue, null);
  };

  // US2028896: Fetch the CURRENT system-computed peak from the incident read
  // (the same endpoint + field fetchProblemDetails reads on load) and refresh
  // the cached value BEFORE opening the resolve confirmation modal. This closes
  // the debounce race: an in-session priority change (EP4→EP3→EP2→EP1→EP4) that
  // is still within the auto-save debounce window when the MIM clicks resolve
  // would otherwise leave computedPeakPriority stale. ComputePeakPriority on the
  // backend walks the full audit trail, so once any earlier EP1 save has landed
  // the peak is EP1 regardless of the current (lower) EP4. Falls back to the
  // existing cached value on fetch failure so the modal never blanks. The
  // state update IS the mechanism: the modal reads computedPeakPriority through
  // its `computedPeak` prop, and updating it here (not inside the modal) also
  // prevents flashing a stale value first. The returned value is incidental —
  // the sole caller awaits this only for sequencing (`.finally` → open the
  // modal) and discards it — so do not rely on the return to get the peak on
  // screen.
  const refreshComputedPeak = async () => {
    try {
      const response = await authFetch(problemURL);
      if (response.ok) {
        const result = await response.json();
        const fresh = result?.computedPeakPriority;
        if (fresh) {
          setComputedPeakPriority(fresh);
          return fresh;
        }
      }
    } catch (err) {
      console.warn(
        "[ProblemForm] Failed to refresh computed peak before resolve modal:",
        err,
      );
    }
    return computedPeakPriority;
  };
  // Keep the ref pointed at the freshest closure for handleStatusChange.
  refreshComputedPeakRef.current = refreshComputedPeak;

  // US2092239: Impact End is no longer a resolve trigger. Setting it is a plain,
  // ungated field write — it never opens the peak-confirmation modal and never
  // implies status "Resolve". Status → Resolve is the only resolve path.
  const onEndChange = (date) => {
    if (!date) return;

    persistIncidentEnd(date);
  };

  // US2028896: Persist a Status→"Resolve" transition confirmed via the modal.
  // Mirrors persistIncidentEnd: apply status locally, freeze Priority to the
  // confirmed peak locally, and carry confirmedPeakPriority on the status PATCH
  // so the backend gate + engine freeze the peak atomically with the resolve.
  const persistStatusResolve = (confirmedPeak, prevStatus) => {
    const newValue = RESOLVE_STATUS;

    // US2092239 (Finding 6): snapshot the pre-resolve status for onError, which
    // cannot reach pendingResolve (handleResolvePeakConfirm nulls it before
    // calling this). This is the ONLY assignment site, which is what lets
    // onError distinguish a rejected resolve from any other failed status write.
    resolveAttemptRef.current = { prevStatus };

    setSaved(false);
    setStatus(createOption(newValue));
    if (confirmedPeak) {
      setPriorityOption({ label: confirmedPeak, value: confirmedPeak });
    }

    setOutage({
      ...outage,
      status: newValue,
      ...(confirmedPeak ? { priority: confirmedPeak } : {}),
    });

    setProblem((prevProblem) => {
      const prevOutageInProblem = prevProblem.outages?.[outageNumber];
      if (!prevOutageInProblem) return prevProblem;
      const updatedOutage = {
        ...prevOutageInProblem,
        status: newValue,
        ...(confirmedPeak ? { priority: confirmedPeak } : {}),
      };
      return {
        ...prevProblem,
        status: newValue,
        outages: {
          ...prevProblem.outages,
          [outageNumber]: updatedOutage,
        },
      };
    });

    // US2092239: IMMEDIATE, not debounced. See
    // handleFieldChangeWithImmediateSave — a debounced resolve is silently
    // discarded if the MIM sets Impact End within the next second, which is the
    // natural workflow now that the two writes are independent.
    handleFieldChangeWithImmediateSave(
      "status",
      newValue,
      prevStatus,
      confirmedPeak ? { confirmedPeakPriority: confirmedPeak } : null,
    );

    NewRelic?.addPageAction("Problem.StatusChanged", {
      problemNumber: problem?.number,
      status: newValue,
    });

    updateTemplates().catch((err) =>
      console.warn(
        "[ProblemForm] template refresh failed on status resolve:",
        err,
      ),
    );
  };

  // US2028896: MIM confirmed (or corrected) the peak — persist the resolve with
  // the confirmed EP value carried on the status PATCH.
  //
  // US2092239: "status" is the ONLY trigger. The former `else if (pending.date)`
  // branch routing an "end" trigger to persistIncidentEnd was unreachable —
  // nothing constructs pendingResolve with trigger "end" any more (the sole
  // setPendingResolve call site passes trigger "status") — and has been removed.
  const handleResolvePeakConfirm = (confirmedPeak) => {
    // Mark this close as a genuine confirm so the onClose() the shared modal
    // fires immediately after onConfirm() is treated as a no-op by
    // handleResolvePeakCancel (rather than reverting the just-applied resolve).
    resolveConfirmedRef.current = true;
    setShowResolvePeakConfirm(false);
    const pending = pendingResolve;
    setPendingResolve(null);
    if (!pending) return;
    if (pending.trigger === "status") {
      persistStatusResolve(confirmedPeak, pending.prevStatus);
    }
  };

  // US2028896: MIM aborted the resolve — discard the pending resolve without
  // writing anything. The incident remains active. For the "status" trigger the
  // Status select is reverted to prevStatus so the dropdown does not display
  // "Resolve" (no status PATCH was sent). For the "end" trigger nothing was
  // applied, so there is nothing to revert.
  const handleResolvePeakCancel = () => {
    // The shared ConfirmationModal calls onClose() right after a successful
    // onConfirm(). In that case the confirm handler already closed the modal and
    // cleared pendingResolve, so skip the revert and reset the guard.
    if (resolveConfirmedRef.current) {
      resolveConfirmedRef.current = false;
      return;
    }
    setShowResolvePeakConfirm(false);
    const pending = pendingResolve;
    setPendingResolve(null);

    // US2092239 (Finding 6): rejectedResolveRef is deliberately NOT cleared
    // here. Cancelling does not persist anything, so nothing about the rejected
    // resolve changed: the server still holds the prior status and outage.status
    // still reads "Resolve" locally. Clearing it would make the NEXT Resolve
    // selection derive prevStatus from that unpersisted "Resolve", skip the gate
    // and send an unconfirmed PATCH — reinstating the dead end this fixes. The
    // ref is cleared only by the paths that actually make it untrue: a
    // successful status save, a non-resolve status change, and a fresh load.

    // US2092239: the Status select is CONTROLLED off `status` state (see its
    // `value` prop). The revert is therefore an ordinary state update and no
    // longer depends on `SimpleMenu` being redeclared each render to remount an
    // uncontrolled react-select — a perf refactor that hoists or memoizes
    // SimpleMenu can no longer silently break Cancel.
    //
    // The guard tests `trigger`, NOT the truthiness of `prevStatus`. Those are
    // different questions: `prevStatus` is legitimately empty whenever
    // `outage.status` was never written or the change lands before hydration
    // finishes, and `shouldOpenResolveModal("Resolve", "")` is true, so a
    // pending resolve with an empty prevStatus is reachable. The old
    // `&& pending.prevStatus` conflated "no pending resolve" with "pending
    // resolve whose prevStatus was empty" and skipped the revert for the latter.
    if (pending?.trigger !== "status") return;

    if (pending.prevStatus) {
      setStatus(createOption(pending.prevStatus));
      return;
    }

    // No prior status to restore. Leaving the select on whatever it currently
    // displays is correct: the controlled `value` was never moved to "Resolve"
    // (handleStatusChange returns before setStatus on this path), and writing
    // createOption("") would blank the dropdown instead of reverting it. Warn
    // rather than pass silently — an empty persisted status is itself a data
    // problem worth seeing in the console alongside the record.
    console.warn(
      "[ProblemForm] resolve cancelled with no previous status to restore; " +
        "outage.status was empty",
      { problemNumber: problem?.number, outage: outageNumber },
    );
  };

  // Generated by GitHub Copilot
  const onEOCNotifiedChange = (date) => {
    if (date) {
      const oldValue = eocNotified ? eocNotified.getTime() : null;
      const newValue = date.getTime();

      setEOCNotified(date);

      let currentOutage = outage;
      currentOutage.eocNotified = newValue;

      setOutage({ ...outage, eocNotified: currentOutage.eocNotified });
      problem.outages[outageNumber] = currentOutage;
      setProblem(problem);
      setSaved(false);

      // Auto-save the date field
      handleFieldChangeWithAutoSave("eoc_notified", newValue, oldValue);
    }
  };

  // Generated by GitHub Copilot
  const onTechTimeResolvedChange = (date) => {
    if (date) {
      const oldValue = techTimeResolved ? techTimeResolved.getTime() : null;
      const newValue = date.getTime();

      setTechTimeResolved(date);

      let currentOutage = outage;
      currentOutage.techTimeResolved = newValue;

      setOutage({
        ...outage,
        techTimeResolved: currentOutage.techTimeResolved,
      });
      problem.outages[outageNumber] = currentOutage;
      setProblem(problem);
      setSaved(false);

      // Auto-save the date field
      handleFieldChangeWithAutoSave("tech_time_resolved", newValue, oldValue);
    }
  };

  // Generated by GitHub Copilot
  const onNextUpdateChange = (date) => {
    if (date) {
      const oldValue = nextUpdate ? nextUpdate.getTime() : null;
      const newValue = date.getTime();

      // const newEnd = dayjs(date);
      setNextUpdate(date);

      let currentOutage = outage;
      currentOutage.nextUpdate = newValue;

      setOutage({
        ...outage,
        nextUpdate: currentOutage.nextUpdate,
      });

      problem.outages[outageNumber] = currentOutage;
      setProblem(problem);
      setSaved(false);

      // Auto-save the date field
      handleFieldChangeWithAutoSave("next_update", newValue, oldValue);
    }
  };

  const handlePriorityChange = useCallback(
    (priority) => {
      const newValue = priority.value;
      let oldValue;

      setSaved(false);
      setPriorityOption(priority);

      // Use functional updater to avoid race conditions
      setOutage((prevOutage) => {
        oldValue = prevOutage.priority;
        return { ...prevOutage, priority: newValue };
      });

      setProblem((prevProblem) => {
        const prevOutageInProblem = prevProblem.outages?.[outageNumber];
        if (!prevOutageInProblem) return prevProblem;

        const updatedOutage = {
          ...prevOutageInProblem,
          priority: newValue,
        };

        return {
          ...prevProblem,
          outages: {
            ...prevProblem.outages,
            [outageNumber]: updatedOutage,
          },
        };
      });

      // Generated by GitHub Copilot - Story 08 Phase 2: Auto-save priority changes
      handleFieldChangeWithAutoSave("priority", newValue, oldValue);
      // US1989003: show refresh indicator immediately; cleared by updateConsolidatedWorkflows finally
      setWorkflowsRefreshing(true);
      setWorkflowsChangedSinceLoad(true);
    },
    [outageNumber, handleFieldChangeWithAutoSave],
  );

  // Generated by GitHub Copilot
  // Fetch fresh templates to reflect current problem state (status, sent communications, etc)
  // Throws on error — callers must .catch() or use .then(...).catch(...)
  const updateTemplates = useCallback(async () => {
    if (!params.id) {
      return;
    }

    try {
      const templates = await TemplateAPI.get(params.id);
      if (templates) {
        const options = Object.keys(templates).map((t) => {
          return {
            label: templates[t].name,
            value: templates[t].name,
            type: t,
            priority: templates[t].priority,
          };
        });

        options.sort((a, b) => {
          const lessthan = a.priority < b.priority ? -1 : 1;
          return lessthan;
        });
        setTemplateOptions(options);
      }
    } catch (error) {
      console.error("Error updating templates:", error);
      throw error;
    }
  }, [params.id]);

  const handleStatusChange = useCallback(
    (status) => {
      const newValue = status.value;
      let oldValue;

      // US2028896: A new resolve via the Status dropdown (status transitioning
      // to "Resolve" while NOT already resolved this session) must be gated
      // behind the MIM peak-priority confirmation. Read
      // the pre-change status synchronously from outage.status (the source of
      // truth also used below for oldValue) and, when this is a new resolve,
      // stash the pending status resolve, open the modal, and RETURN before
      // mutating state or PATCHing. persistStatusResolve applies everything on
      // confirm; handleResolvePeakCancel reverts the dropdown on cancel.
      //
      // US2092239: this is the ONLY resolve gate, and it is keyed on status
      // alone — it prompts whenever the pre-change status is not already
      // "Resolve". A set Impact End no longer suppresses the prompt, so a stale
      // or resurrected Impact End can no longer lock an incident out of being
      // resolved (INC4856794). It no longer mirrors onEndChange: onEndChange is
      // now an ungated field write that never opens this modal, so there is
      // nothing on the Impact End side left to mirror.
      // shouldOpenResolveModal is a pure imported function and therefore stable,
      // so it needs no place in this useCallback's dep array.
      //
      // US2092239 (Finding 6): outage.status is not always a truthful basis for
      // the gate. A rejected resolve is not rolled back, so outage.status reads
      // "Resolve" locally while the server still holds the prior status — the
      // gate would refuse to prompt and re-selecting Resolve would send an
      // unconfirmed PATCH straight into a second silent 400. rejectedResolveRef
      // carries the true pre-resolve status forward for exactly that window; it
      // is cleared on every path that makes it stale (successful status save, any
      // non-resolve status change including a reopen, and a fresh load), so
      // outside that window gatePrevStatus is just `prevStatus`.
      //
      // Two deliberate narrowings. (1) The override feeds the GATE and the
      // pendingResolve it builds — whose prevStatus is the dropdown's cancel
      // target and the resolve PATCH's oldValue, both of which want the true
      // prior status — but NOT `isReopen` below, which asks about the DISPLAYED
      // status and so must keep reading outage.status. (2) The PRESENCE of the
      // ref is the signal, not the truthiness of its prevStatus: an absent or
      // empty pre-resolve status is legitimate (same distinction drawn in
      // handleResolvePeakCancel) and shouldOpenResolveModal("Resolve", "") is
      // true, so keying on the value would fall back to the unpersisted
      // "Resolve" in the very case the gate most needs to open.
      const prevStatus = outage?.status;
      const rejectedResolve = rejectedResolveRef.current;
      const gatePrevStatus = rejectedResolve
        ? rejectedResolve.prevStatus
        : prevStatus;
      if (shouldOpenResolveModal(newValue, gatePrevStatus)) {
        setPendingResolve({ trigger: "status", prevStatus: gatePrevStatus });
        // US2028896: refresh the system-computed peak before opening the modal
        // so it presents the true current peak even when an in-session priority
        // change is still within the auto-save debounce. (This refresh used to
        // be shared with onEndChange; US2092239 made onEndChange ungated, so
        // this is now the only caller.)
        refreshComputedPeakRef.current().finally(() =>
          setShowResolvePeakConfirm(true),
        );
        return;
      }

      // US2092239 (Finding 6): past the gate, so this is NOT a new resolve — it
      // is a reopen or a move between non-resolved statuses. Either way it
      // supersedes any rejected resolve: this write now owns the field, and a
      // surviving override would prompt on a later change that needs no
      // confirmation. Clearing the attempt snapshot as well is what stops a
      // failure of THIS write from arming the gate in onError with a prevStatus
      // that no longer describes anything.
      resolveAttemptRef.current = null;
      rejectedResolveRef.current = null;

      // US2043931: A reopen — status transitioning OUT of "Resolve". The backend
      // clears the persisted IncidentEnd on this transition (SaveProblem reverse
      // coupling); here we mirror that in-session so the displayed Impact End
      // matches what was persisted without requiring a page reload. Clear it in
      // all three places state can resurrect it from: the top-level
      // `incidentEnd` Date, `outage.incidentEnd`, and
      // `problem.outages[n].incidentEnd`.
      // US2092239: this is no longer what re-arms the resolve gate — the gate is
      // keyed on status alone, so it re-arms the moment the status leaves
      // "Resolve" regardless of Impact End.
      const reopen = isReopen(prevStatus, newValue);
      if (reopen) {
        setIncidentEnd();
      }

      setSaved(false);
      setStatus(createOption(newValue));

      // Use functional updater to avoid race conditions
      setOutage((prevOutage) => {
        oldValue = prevOutage.status;
        return {
          ...prevOutage,
          status: newValue,
          ...(reopen ? { incidentEnd: 0 } : {}),
        };
      });

      setProblem((prevProblem) => {
        const prevOutageInProblem = prevProblem.outages?.[outageNumber];
        if (!prevOutageInProblem) return prevProblem;

        const updatedOutage = {
          ...prevOutageInProblem,
          status: newValue,
          ...(reopen ? { incidentEnd: 0 } : {}),
        };

        return {
          ...prevProblem,
          status: newValue,
          outages: {
            ...prevProblem.outages,
            [outageNumber]: updatedOutage,
          },
        };
      });

      // Generated by GitHub Copilot - Story 08 Phase 2: Auto-save status changes
      handleFieldChangeWithAutoSave("status", newValue, oldValue);

      NewRelic?.addPageAction("Problem.StatusChanged", {
        problemNumber: problem?.number,
        status: newValue,
      });

      // Generated by GitHub Copilot
      // Refresh templates when status changes (e.g., to Resolved) to update available options
      updateTemplates().catch((err) => console.warn('[ProblemForm] template refresh failed on status change:', err));
    },
    [
      outageNumber,
      handleFieldChangeWithAutoSave,
      createOption,
      updateTemplates,
      // US2028896: read for the Status→Resolve confirmation gate.
      // US2092239: `incidentEnd` is no longer read here — the gate is keyed on
      // status alone — so it is deliberately absent from this dep array.
      outage,
    ],
  );

  const handleSlackChange = (option) => {
    const oldValue = outage.slackChannel;
    const newValue = option.label;

    outage.slackChannel = newValue;
    setOutage({ ...outage, slackChannel: newValue });

    setSlack(option);
    setSaved(false);

    // Generated by GitHub Copilot - Story 08 Phase 2: Auto-save slack channel changes
    handleFieldChangeWithAutoSave("slack_channel", newValue, oldValue);
  };

  const handleAffectedUsersChange = (option) => {
    const oldValue = affectedUserOption ? affectedUserOption.label : "";
    const newValue = option ? option.label : "";

    setSaved(false);
    outage.affectedUsers = option.label;
    setOutage({ ...outage, affectedUsers: option.label });

    setShowExternalMessage(option.label !== "Internal");

    setAffectedUserOption(option);

    // Generated by GitHub Copilot - Trigger auto-save for select field
    handleFieldChangeWithAutoSave("affected_users", newValue, oldValue);
  };

  const handleAffectedBrandChange = (options) => {
    const oldValue = affectedBrands;
    const newValue = options;

    setSaved(false);
    setAffectedBrands(options);
    outage.affectedBrandCapability = options;
    setOutage(outage);

    problem.outages[outageNumber] = outage;
    setProblem({ ...problem, outages: problem.outages });

    // Generated by GitHub Copilot - Trigger auto-save for multi-select
    handleFieldChangeWithAutoSave("affected_brands", newValue, oldValue);
  };

  const handleImpactedProductChange = (options) => {
    const oldValue = impactedApplications;
    const newValue = options;

    setSaved(false);
    setImpactedApplications(options);

    outage.impactedApplications = options;
    setOutage(outage);

    problem.outages[outageNumber] = outage;
    setProblem({ ...problem, outages: problem.outages });

    setStatusApplications(formatProductStatus(options));

    // Generated by GitHub Copilot - Trigger auto-save for multi-select
    // resolveIncidentCommanders will be called via onSaved callback after save completes
    handleFieldChangeWithAutoSave("impacted_applications", newValue, oldValue);
  };

  const handleCommanderChange = (option) => {
    const oldValue = outage.incidentCommander;
    const newValue = option.label;

    setSaved(false);
    setIncidentCommander(option);
    outage.incidentCommander = newValue;

    // Generated by GitHub Copilot
    // Set commanderOverride based on whether the selected commander is from the standard list
    const isStandardSelection = isStandardCommander(option);
    setCommanderOverride(!isStandardSelection);
    outage.commanderOverride = !isStandardSelection;

    setOutage(outage);
    problem.outages[outageNumber] = outage;
    setProblem({ ...problem, outages: problem.outages });

    // Generated by GitHub Copilot - Story 08 Phase 2: Auto-save commander changes
    handleFieldChangeWithAutoSave("commander", newValue, oldValue);
  };

  const handleCommanderCreate = (option) => {
    setCommanderOverride(true);

    outage.commanderOverride = true;
    setOutage(outage);
    problem.outages[outageNumber] = outage;
    setProblem({ ...problem, outages: problem.outages });
  };

  const saveChanges = () => {
    saveProblemUpdates(problem, function (id) {
      setSaved(true);
      setLoaded(false);

      setNumberEditable(false);
      if (problem && problem.number && problem.number.startsWith("PRBT")) {
        setNumberEditable(true);
      }

      const destination = "/problem/edit/" + problem.number;

      // removing for US1382802
      // if (
      //   problem.outages["OUTAGE 1"] &&
      //   problem.outages["OUTAGE 1"].status === "Resolve"
      // ) {
      //   destination = "/problems";
      // }
      navigate(destination);
    });
    setTimeout(() => {}, 1000);
  };

  // Handle number field changes (auto-save disconnected). Normalize to trimmed
  // upper-case: PRB/INC numbers are upper-case and the backend validators are
  // anchored and case-sensitive (types/validation.go), so a rename to
  // "inc4449471" or a paste of "INC4449471 " out of ServiceNow/Slack/Teams
  // resolves the same as "INC4449471". Same normalization order as
  // isPermanentTargetNumber in utils/incidentLinkage.js, so the field and the
  // promotion predicate always agree on the value.
  const onNumberChange = (e) => {
    const nextNumber = e.target.value.trim().toUpperCase();
    setProblem({
      ...problem,
      [e.target.id]: nextNumber,
    });
    setSaved(false);
    setNumberModified(true);
    // US2097708 (A5): record the edit so the in-flight save's success path can
    // tell that the field has moved on from what it sent. Only meaningful
    // while a PATCH is running; outside that window the save that reads it
    // resets it first.
    if (numberSaveInFlightRef.current) {
      numberEditedDuringSaveRef.current = nextNumber;
    }
    // Editing the field invalidates the previous save attempt. Without this a
    // failed save leaves a stale red error pinned under a value the operator
    // has since changed (including restoring the original), with no way to
    // clear it short of a page refresh.
    //
    // US2097708 (A5): but ONLY when no save is in flight. The save button is
    // disabled on numberSaveStatus === "saving", so clearing the status while
    // a PATCH is running re-enables the button mid-request and a second click
    // fires a second concurrent PATCH with a different `number` -- two
    // unversioned last-write-wins writes racing on the one field this story is
    // about.
    //
    // Skipping the clear here does not strand a stale error, because the error
    // is never raised against a superseded value in the first place:
    // reportNumberSaveFailure re-reads numberEditedDuringSaveRef (recorded
    // just above) when the request resolves, and goes to "idle" instead of
    // "error" if the field has moved on. The two clears are complementary, not
    // redundant -- this one handles an edit made AFTER a failure has resolved,
    // that one handles an edit made BEFORE it resolves -- and only the
    // resolution-time one can act without re-enabling the button mid-request.
    if (!numberSaveInFlightRef.current) {
      setNumberSaveStatus("idle");
      setNumberSaveError("");
    }
  };

  // US2097708 (A4): cancel any pending "saved" -> "idle" reset so it cannot
  // fire against a later save. Called before arming a new timer and at the top
  // of every save attempt.
  const clearNumberSaveResetTimer = () => {
    if (numberSaveResetTimerRef.current) {
      clearTimeout(numberSaveResetTimerRef.current);
      numberSaveResetTimerRef.current = null;
    }
  };

  // US2097708: report a failed number save -- unless the operator has already
  // replaced the value while the PATCH was in flight, in which case the
  // message describes a number that is no longer on screen. Pinning it under
  // the newer value is the exact stale-error state onNumberChange's clear
  // exists to prevent, and onNumberChange cannot do that clearing itself
  // during the in-flight window without re-enabling the save button
  // mid-request (the concurrency race). Deciding it HERE instead, once the
  // request has already resolved, costs nothing: the request is over, so
  // re-enabling the button is now correct rather than dangerous.
  //
  // sentNumber is passed in rather than read from `problem` so it is
  // unambiguously the value the PATCH carried: `problem` is captured from the
  // render that produced the handler, and a mid-flight keystroke re-renders
  // with a new closure the running invocation never sees.
  //
  // Retyping the value that was sent is not "moving on" -- the rejection still
  // describes what is on screen -- so that case keeps its error, matching the
  // success path's treatment of a retyped-to-identical value.
  const reportNumberSaveFailure = (message, sentNumber) => {
    const editedDuringSave = numberEditedDuringSaveRef.current;
    if (editedDuringSave !== null && editedDuringSave !== sentNumber) {
      setNumberSaveStatus("idle");
      setNumberSaveError("");
      return;
    }
    setNumberSaveError(message);
    setNumberSaveStatus("error");
  };

  // Generated by GitHub Copilot - Save problem number change via PATCH API
  // Resolves { ok, oldNumber, newNumber, promoted } so the unsaved-number
  // prompt can continue only after a successful save.
  const saveNumberChange = async () => {
    if (!problem.number || problem.number === originalNumber) {
      return { ok: false };
    }

    // US2097708 (A5): defence in depth behind the button's disabled state.
    // State is not a reliable interlock for a data-corruption path -- React
    // batching, a future edit to the disabled predicate, or a programmatic
    // call can all get a second invocation past the button -- so refuse here,
    // where the request is actually issued.
    //
    // The re-entry check stays OUTSIDE the try -- it has to run before
    // anything else -- but the flag is set as the FIRST statement INSIDE it,
    // so the finally below covers every path that can set it. Setting it here
    // instead would leak it permanently if any statement between the set and
    // the try threw, and onNumberChange keys its status-clear on this same
    // ref: a leaked flag wedges the field with no save able to fire AND no way
    // to clear a stale error short of a page reload. Nothing can interleave in
    // the gap, because it is straight-line synchronous code up to the first
    // await inside the try.
    if (numberSaveInFlightRef.current) {
      return { ok: false };
    }

    clearNumberSaveResetTimer();

    setNumberSaveStatus("saving");
    setNumberSaveError("");

    // Held outside the try so the catch can tell the failure modes apart: still
    // null means nothing ever came back from the network, non-null means the
    // server answered (and answered 2xx, since the !response.ok arm returns).
    let response = null;

    try {
      numberSaveInFlightRef.current = true;
      numberEditedDuringSaveRef.current = null;

      response = await authFetch(`/api/v1/problem/${params.id}/field`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fieldPath: "number",
          value: problem.number,
        }),
      });

      if (!response.ok) {
        // Surface the server's reason (e.g. an INC that isn't an existing EOC
        // Bridge incident) so the user knows why the rename was rejected.
        const errorData = await response.json().catch(() => ({}));
        console.error("[ProblemForm] Number save failed:", errorData);
        reportNumberSaveFailure(
          errorData.message ||
            "Could not save the number. Please check it and try again.",
          problem.number
        );
        return { ok: false };
      }

      const result = await response.json();

      // Check if this was a temp→real conversion
      const oldNumber = originalNumber;
      const newNumber = problem.number;

      setNumberSaveStatus("saved");

      // US2097708 (A5): only call the field unmodified if it still holds what
      // was actually saved. If the operator typed while the PATCH was in
      // flight, the A5 interlock (correctly) refused the second PATCH, so the
      // newer value is on screen but was never sent -- clearing the flag here
      // would disable the save button and strand it, leaving the operator a
      // green tick over a number the server does not have and no affordance to
      // fix it but typing another character. A retyped-to-identical value is
      // treated as unmodified, matching the button's own value checks.
      const editedDuringSave = numberEditedDuringSaveRef.current;
      if (editedDuringSave === null || editedDuringSave === newNumber) {
        setNumberModified(false);
      }
      setSaved(true);

      // US2097708: a PRBT may be promoted to a real PRB *or* to an INC. Both leave
      // the browser on a dead PRBT URL, so both must take this branch.
      const promoted = oldNumber.startsWith("PRBT") && isPermanentTargetNumber(newNumber);
      if (promoted) {
        // Update local state before navigation
        setNumberEditable(false);
        setProblem((prev) => ({
          ...prev,
          temporary: false,
          number: newNumber,
        }));
        setOriginalNumber(newNumber);
        // Navigate to the new problem URL with the real PRB number
        const carriedTab = heldExitTabRef.current;
        navigate(`/problem/edit/${newNumber}/outage/${params.outage}`, {
          replace: true,
          ...(carriedTab && { state: { unsavedNumberTab: carriedTab } }),
        });
      } else {
        // Update the original number to the new value
        setOriginalNumber(newNumber);
        // Update temporary flag based on whether new number starts with PRBT
        setProblem((prev) => ({
          ...prev,
          temporary: newNumber.startsWith("PRBT"),
        }));
      }

      // Reset status back to idle after 2 seconds. Tracked in a ref (A4) so a
      // later save can cancel it instead of having it re-enable the button
      // mid-flight.
      clearNumberSaveResetTimer();
      numberSaveResetTimerRef.current = setTimeout(() => {
        numberSaveResetTimerRef.current = null;
        setNumberSaveStatus("idle");
      }, 2000);
      return { ok: true, oldNumber, newNumber, promoted };
    } catch (error) {
      // Three genuinely different failures land here and each needs different
      // advice. Without a message the inline error below renders nothing (it
      // requires BOTH the status and the message), leaving a red button and no
      // explanation -- but a wrong message is worse than none:
      //   * error.status === 401 -- authFetch (utils/authFetch.js, the
      //     `response.status === 401 && !skipAuthCheck` arm of authFetch) throws
      //     AFTER fetch resolved with a 401, so the request DID reach the
      //     server and the server refused it. Nothing was written and the
      //     connection is fine, so do not send the operator to check it.
      //     authFetch has already dispatched the global auth-error-401 event;
      //     all we do here is describe what happened.
      //   * response still null -- nothing came back at all (offline, DNS,
      //     transport). The PATCH genuinely did not reach the server, so a
      //     retry is the right advice.
      //   * response in hand -- the PATCH returned 2xx (a non-ok response
      //     returns in the arm above), so the rename IS ALREADY PERSISTED and
      //     something after it threw. Advising a blind retry would send a
      //     second rename at a record that has already moved on, which the AC4
      //     promoted-record write guard refuses with a 409
      //     (promoted_record_write_refused) -- the exact self-referential
      //     confusion this story exists to remove. Reload and look first.
      console.error("[ProblemForm] Number save error:", error);

      let message;
      if (error?.status === 401) {
        message =
          "Could not save the number \u2014 your session expired, so the server " +
          "refused the request. The number was not changed. Sign in again, " +
          "then retry.";
      } else if (response) {
        message =
          "The server accepted the number change, but this page could not " +
          "finish updating. The rename may already be saved \u2014 reload this " +
          "page and check the number before trying again.";
      } else {
        message =
          "Could not save the number \u2014 the request did not reach the server. " +
          "Check your connection, then try again.";
      }

      reportNumberSaveFailure(message, problem.number);
      return { ok: false };
    } finally {
      // Every exit from the attempt runs through here: the !response.ok early
      // return, all three catch branches, and the success path. A leaked flag
      // would wedge the field permanently (no further save could ever fire and
      // typing could never clear a stale error), so it must not be released
      // anywhere but here.
      numberSaveInFlightRef.current = false;
    }
  };

  // Throws on error — callers must .catch() or use .then(...).catch(...)
  const updateCommunications = (cb) => {
    return fetch(problemURL)
      .then((res) => {
        if (!res.ok) {
          setLoaded(true);
          throw new Error('fetch-not-ok');
        }
        return res.json();
      })
      .then((result) => {
        if (!result?.problem) {
          alert("no problem?");
          throw new Error('no-problem-in-result');
        }
        cb && cb(result.problem.communications);
      })
      .catch((error) => {
        console.error("[ProblemForm] Update communications error:", error);
        throw error;
      });
  };

  // Throws on error — callers must .catch() or use .then(...).catch(...)
  const updateNotes = async () => {
    try {
      const notesResponse = await NotesAPI.get(params.id, "OUTAGE 1");
      setNotes(notesResponse);
    } catch (error) {
      console.error("Failed to update notes:", error);
      setLoaded(true);
      throw error;
    }
  };

  // Generated by GitHub Copilot
  // Resolve incident commanders by converting array of strings to option objects
  const resolveIncidentCommanders = (commanders) => {
    if (!commanders || commanders.length === 0) {
      setDefaultCommanders([]);
      // setCommanderOptions([]);
      return;
    }

    const commanderOpts = commanders.map((c) => createOption(c));
    setDefaultCommanders(commanderOpts);
    // setCommanderOptions(commanderOpts);
  };

  // Generated by GitHub Copilot
  // Extract commander list from outage data (helper for resolveIncidentCommanders)
  const extractCommanderList = (commanderData) => {
    if (!commanderData) {
      return [];
    }

    // Prioritize new defaultCommanders field from delivery stream resolution
    if (
      commanderData.defaultCommanders &&
      commanderData.defaultCommanders.length > 0
    ) {
      return commanderData.defaultCommanders;
    }

    // Fall back to legacy commanderOptions field for backward compatibility
    if (
      commanderData.commanderOptions &&
      commanderData.commanderOptions.length > 0
    ) {
      return commanderData.commanderOptions;
    }

    return [];
  };

  const switchTab = (key) => {
    const startMs = Date.now();
    setTabKey(key);

    const fireTabLoaded = (success) => {
      try {
        NewRelic?.addPageAction('Tab.Loaded', {
          tab_context: 'ProblemForm',
          tab_name: key,
          problemNumber: problem?.number,
          success,
          load_time_ms: Date.now() - startMs,
        });
      } catch (nrErr) {
        console.warn('[ProblemForm] Tab.Loaded tracking failed:', nrErr);
      }
    };

    if (key === "history") {
      updateCommunications().then(() => fireTabLoaded(true)).catch(() => fireTabLoaded(false));
    } else if (key === "timeline") {
      updateNotes().then(() => fireTabLoaded(true)).catch(() => fireTabLoaded(false));
    } else if (key === "paging") {
      // Generated by GitHub Copilot
      // Fetch fresh consolidated workflows when paging tab is selected to reflect current priority/state
      // US1989003: show loading indicator while GET is in flight (AC1)
      setWorkflowsRefreshing(true);
      updateConsolidatedWorkflows().then(() => fireTabLoaded(true)).catch(() => fireTabLoaded(false));
    } else if (key === "communications") {
      // Generated by GitHub Copilot
      // Refresh templates when switching to communications tab to reflect current status
      updateTemplates().then(() => fireTabLoaded(true)).catch(() => fireTabLoaded(false));
      fetchReportedImpacts(); // US1873550: Refresh snapshot so it's never stale at send time.
    } else {
      // Generated by GitHub Copilot
      // Auto-refresh version history when revisions tab is selected
      if (
        key === "revisions" &&
        versionHistoryRef.current &&
        versionHistoryRef.current.refreshVersions
      ) {
        versionHistoryRef.current.refreshVersions();
      }
      fireTabLoaded(true);
    }
  };

  // US2138216: the number is the one field that needs a manual save, and an
  // unsaved PRBT number leaves the MIM working the temporary record, so any
  // exit or tab switch is held until they save, leave it, or stay. The page's
  // own redirects call navigate directly and never come through here.
  const numberUnsaved = isUnsavedPrbtNumber(originalNumber, problem?.number);
  unsavedNumberDraftRef.current = numberUnsaved
    ? { original: originalNumber, value: problem.number }
    : null;

  const requestExit = (destination, proceed, tab) => {
    if (!numberUnsaved) {
      proceed();
      return;
    }
    // One held exit at a time: a late one (a search lookup resolving) yields
    // to the exit the MIM is already answering.
    if (pendingExit) {
      return;
    }
    const exit = { destination, tab, proceed };
    holdExit(exit);
    // Mid-save, neither "leave it as the PRBT" nor "save" is a true choice:
    // hold the exit in the modal's saving state and act on the outcome.
    if (numberSaveStatus === "saving" && numberSavePromiseRef.current) {
      numberSavePromiseRef.current.then((saveResult) =>
        finishExitAfterSave(exit, saveResult, { waited: true }),
      );
    }
  };

  const holdExit = (exit) => {
    heldExitTabRef.current = exit.tab ?? null;
    setPendingExit(exit);
  };

  const releaseExit = () => {
    heldExitTabRef.current = null;
    setPendingExit(null);
  };

  const changeTabs = (key) => {
    if (key === tabKey) {
      switchTab(key);
      return;
    }
    requestExit(
      `tab:${key}`,
      (_path, saveResult) => {
        // A promotion remounts the form; the new instance applies the tab.
        if (!saveResult?.promoted) {
          switchTabRef.current(key);
        }
      },
      key,
    );
  };

  const recordUnsavedNumberPrompt = (outcome, destination, extra) => {
    try {
      NewRelic?.recordCustomEvent?.("ProblemNumberUnsavedPrompt", {
        outcome,
        problemNumber: originalNumber,
        attemptedNumber: problem?.number,
        destination,
        ...extra,
      });
    } catch (nrErr) {
      console.warn("[ProblemForm] ProblemNumberUnsavedPrompt tracking failed:", nrErr);
    }
  };

  const stayWithUnsavedNumber = () => {
    const exit = pendingExit;
    // The modal stays clickable while it fades out, after the exit is gone.
    if (!exit) {
      return;
    }
    recordUnsavedNumberPrompt("stayed", exit.destination);
    focusNumberOnModalExitRef.current = true;
    releaseExit();
  };

  const leaveWithoutSavingNumber = () => {
    const exit = pendingExit;
    if (!exit) {
      return;
    }
    recordUnsavedNumberPrompt("left", exit.destination);
    releaseExit();
    // Show the record actually being worked; otherwise the next tab switch
    // would prompt again for a number the MIM chose not to keep.
    setProblem((prev) => ({ ...prev, number: originalNumber }));
    setNumberModified(false);
    setNumberSaveStatus("idle");
    setNumberSaveError("");
    setExitAfterReset(exit);
  };

  useEffect(() => {
    if (exitAfterReset) {
      setExitAfterReset(null);
      exitAfterReset.proceed();
    }
  }, [exitAfterReset]);

  const saveNumberAndContinue = async () => {
    const exit = pendingExit;
    if (!exit) {
      return;
    }
    numberSavePromiseRef.current = saveNumberChange();
    finishExitAfterSave(exit, await numberSavePromiseRef.current, { waited: false });
  };

  // `waited` marks an exit held behind a save the MIM started from the field's
  // own button, rather than one they chose Save and continue for.
  const finishExitAfterSave = (exit, saveResult, { waited }) => {
    if (!saveResult.ok) {
      releaseExit();
      // saveNumberChange has already put the reason under the field.
      recordUnsavedNumberPrompt("save_failed", exit.destination, { waited });
      focusNumberOnModalExitRef.current = true;
      return;
    }
    // The field moved on while the save was in flight (A5 tracks it), so the
    // number on screen is still unsaved: ask again rather than leave it behind.
    // A promotion has already left this form, as US2097708 defines.
    const editedDuringSave = numberEditedDuringSaveRef.current;
    if (
      !saveResult.promoted &&
      editedDuringSave !== null &&
      isUnsavedPrbtNumber(saveResult.newNumber, editedDuringSave)
    ) {
      holdExit(exit);
      return;
    }
    releaseExit();
    recordUnsavedNumberPrompt("saved", exit.destination, { waited });
    exit.proceed(
      rewriteProblemNumberInPath(exit.destination, saveResult.oldNumber, saveResult.newNumber),
      saveResult,
    );
  };

  const focusNumberAfterModal = () => {
    if (focusNumberOnModalExitRef.current) {
      focusNumberOnModalExitRef.current = false;
      numberInputRef.current?.focus();
    }
  };

  // US2138216: a Save and continue that promoted the record carried its
  // pending tab on the redirect. The history entry is cleared at once, without
  // a router navigation (which would re-run the initial load), so a reload or
  // Back/Forward does not reopen it; the tab is applied once the load settles.
  useEffect(() => {
    if (window.history.state?.usr?.unsavedNumberTab) {
      window.history.replaceState({ ...window.history.state, usr: null }, "");
    }
  }, []);

  useEffect(() => {
    const promotedTab = promotedPendingTabRef.current;
    if (initialLoadSettled && promotedTab) {
      promotedPendingTabRef.current = null;
      switchTabRef.current(promotedTab);
    }
  }, [initialLoadSettled]);

  // Includes a save in flight: closing the tab may cancel the PATCH.
  useEffect(() => {
    if (!numberUnsaved) {
      return undefined;
    }
    const warnBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warnBeforeUnload);
    return () => window.removeEventListener("beforeunload", warnBeforeUnload);
  }, [numberUnsaved]);

  switchTabRef.current = switchTab;

  const disconnectPagerDuty = () => {
    let requestOptions = {
      method: "DELETE",
      // headers: { "Content-type": "application/json" },
    };

    const apiURL = problemURL + "/" + outage.number + "/pagerduty";

    fetch(apiURL, requestOptions)
      .then((res) => {
        if (!res.ok) {
          console.error("PagerDuty API error response:", res.statusText);
        }
        return res;
      })
      .then((res) => res.json())
      .then((result) => {
        if (result.ok) {
          setpagerDutyIncident();
          // US2080752 (PR #623 review): clear any stale inline message + input
          // so a prior save-with-warning (amber) or error (red) doesn't linger
          // on the now-empty PagerDuty field after disconnect.
          setPagerDutyFieldMessage(null);
          setEnteredPagerDutyIncident("");
          // US2080752: clear the dedupe ref so re-entering the just-disconnected
          // incident ID fires a fresh save/validate instead of being deduped.
          pagerDutyLastSubmittedRef.current = "";
          return;
        }

        if (result.error) {
          // US2077763 (PR #631): apiRemovePageryDuty now returns a version_conflict 409 on a
          // concurrent-edit CAS exhaustion. This hand-rolled DELETE bypasses the useFieldAutoSave
          // 409 handler, so a conflict must reconcile the same way its sibling savePagerDutyIncident
          // does — re-fetch the winning state + show the dismissible notice — instead of landing in
          // this (previously empty) block, where the Disconnect button appeared to do nothing.
          if (result.error.code === "version_conflict") {
            Promise.resolve(fetchProblemDetailsRef.current())
              .catch((e) =>
                console.warn(
                  "[ProblemForm] refetch after PagerDuty-disconnect version conflict failed:",
                  e,
                ),
              )
              .finally(() =>
                setConflictNotice(
                  "This incident was updated by someone else. It has been reloaded to the latest version — please review and re-apply your change if it's still needed.",
                ),
              );
          }
        }
      })
      .catch((err) => {
        console.error("PagerDuty disconnect error:", err);
      });
  };

  const requestPeerReview = async () => {
    // Start NewRelic browser interaction for peer review tracking
    const interaction = NewRelic?.interaction?.() || null;
    if (interaction) {
      interaction.setName('PeerReview.Request');
      interaction.setAttribute('problemNumber', problem.number);
    }

    // Clear any previous feedback before starting a new request
    setSendError(null);
    setPeerReviewSuccess(null);
    // Set loading state for peer review (separate from communication sending)
    setIsRequestingPeerReview(true);

    const peerURL = `/api/v1/problem/${problem.number}/communications/review`;

    const communication = buildPeerReviewPayload({
      outage,
      priorityOption,
      templateOption,
      incidentCommander,
      affectedUserOption,
      slackSmsCommunication,
      nextUpdate,
      incidentStart,
      incidentEnd,
      eocNotified,
      timeDetected,
      techTimeResolved,
      // US1873550: Include snapshot of current reported impacts in peer review payload.
      reportedImpacts,
    });

    try {
      const response = await authFetch(peerURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(communication),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Success: Reset loading state and show success feedback
      setIsRequestingPeerReview(false);
      setPeerReviewSuccess("Peer review request sent successfully");
      setTimeout(() => setPeerReviewSuccess(null), 8000);

      // Track successful peer review in NewRelic
      NewRelic?.addPageAction('PeerReview.Success', {
        problemNumber: problem?.number,
        templateType: templateOption?.value || 'unknown',
      });
      if (interaction) interaction.end();

    } catch (error) {
      // Error handling: show error in tab so user can retry
      console.error("Error requesting peer review:", error);
      setIsRequestingPeerReview(false);
      setSendError(
        `Failed to request peer review. Please try again. ${error.message}`,
      );

      // Track peer review error in NewRelic
      NewRelic?.noticeError(error);
      NewRelic?.addPageAction('PeerReview.Failed', {
        problemNumber: problem?.number,
        templateType: templateOption?.value || 'unknown',
        errorMessage: error?.message,
      });
      if (interaction) interaction.end();
    }
  };

  // US1989003: stale workflows — any workflow-driving field (priority, impacted_applications,
  // affected_brands) changed since last successful GET. React 18 batches state updates in the
  // same synchronous handler, so workflowsRefreshing and workflowsChangedSinceLoad are always
  // set together — guarding on !workflowsRefreshing makes isStale always false.
  const isStale = workflowsChangedSinceLoad;

  return (
    <LightModeLayout>
      <>
        {/* US2028896: resolve-time peak-priority confirmation. Gates the
            transition of an active incident to resolved (Impact End set). */}
        <ResolvePeakConfirm
          isOpen={showResolvePeakConfirm}
          onClose={handleResolvePeakCancel}
          onConfirm={handleResolvePeakConfirm}
          computedPeak={computedPeakPriority}
        />
        <UnsavedNumberModal
          show={!!pendingExit}
          prbtNumber={originalNumber}
          newNumber={problem?.number}
          saving={numberSaveStatus === "saving"}
          onSave={saveNumberAndContinue}
          onLeave={leaveWithoutSavingNumber}
          onStay={stayWithUnsavedNumber}
          onExited={focusNumberAfterModal}
        />
        <Row>
          {/* Generated by GitHub Copilot - Left Navigation with tabs */}
          <Col xs={12} md={3} lg={3} xl={2} className="p-0">
            <LeftNavigation
              user={user}
              newrelic={NewRelic}
              problemId={params.id}
              viewLink={viewLink}
              archived={archived}
              showEditButton={false}
              showImpactCommandCenter={!problem?.temporary}
              showTabs={true}
              activeTab={tabKey}
              onTabChange={changeTabs}
              onBeforeNavigate={requestExit}
              tabs={[
                { key: "primary", label: "Home" },
                { key: "paging", label: "Page" },
                { key: "communications", label: "Send Communications" },
                { key: "history", label: "Comms" },
                { key: "impacts", label: "Impact Reports" },
                { key: "revisions", label: "Revisions" },
                { key: "timeline", label: "Timeline" },
                { key: "reporting", label: "Reporting" },
              ]}
              autoSaveStatus={autoSaveStatus}
              autoSaveError={autoSaveError}
            />
          </Col>
          {/* Main content column */}
          <Col xs={12} md={9} lg={9} xl={10} className="problemGuts">
            {/* US2077763: dismissible version-conflict notice. Shown after a field
                auto-save loses a 409 CAS race and the form reloads to the latest
                server state. Reuses the existing react-bootstrap Alert. This is the
                conflict (409) surface only — distinct from the refused-save banner
                (data-testid="field-save-error") rendered further down. */}
            {conflictNotice && (
              <Alert
                variant="warning"
                dismissible
                onClose={() => setConflictNotice(null)}
                className="mt-2"
                data-testid="version-conflict-notice"
              >
                {conflictNotice}
              </Alert>
            )}
            {/* US2097708 (merge collapse): the second, duplicate refused-save Alert that
                used to render here (data-testid="autosave-error-alert") is GONE. It and
                main's data-testid="field-save-error" block below were added on separate
                branches into this same column and auto-merged with no conflict, so a
                rejected Status or Impact End save rendered two banners for one failure.
                Everything this one contributed — the hook's all-field reach, the field
                label on the headline, and the multi-field list — is preserved in that one
                surviving banner; see collectRefusedFieldSaves. */}
            <Row className="firstRow">
              <Col xs={12} sm={8} md={8} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="number">
                  <Form.Label>
                    <FaHashtag />
                    &nbsp; {numberEditable ? "Temporary " : ""}Problem Number
                  </Form.Label>

                  <InputGroup>
                    <Form.Control
                      size="md"
                      type="text"
                      placeholder="PRBXXXXX"
                      value={problem && problem.number ? problem.number : ""}
                      readOnly={!numberEditable}
                      onChange={onNumberChange}
                      ref={numberInputRef}
                      disabled={!archived && !numberEditable}
                      data-testid="problem-number-input"
                      aria-invalid={numberSaveStatus === "error"}
                      aria-describedby={
                        numberSaveStatus === "error" && numberSaveError
                          ? "problem-number-save-error"
                          : undefined
                      }
                    />
                    <Button
                      variant={
                        numberSaveStatus === "error"
                          ? "outline-danger"
                          : numberSaveStatus === "saved"
                            ? "outline-success"
                            : "outline-primary"
                      }
                      // Mirrors saveNumberChange's own guard so an enabled
                      // button ALWAYS results in a request. numberModified goes
                      // true on any keystroke, so without the value checks the
                      // button is clickable in states the guard silently
                      // rejects (field cleared, or original value restored).
                      disabled={
                        !numberModified ||
                        numberSaveStatus === "saving" ||
                        !problem?.number ||
                        problem.number === originalNumber
                      }
                      onClick={() => {
                        numberSavePromiseRef.current = saveNumberChange();
                      }}
                      data-testid="problem-number-save-button"
                    >
                      {numberSaveStatus === "saving" ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <FaFloppyDisk />
                      )}
                    </Button>
                  </InputGroup>
                  {numberSaveStatus === "error" && numberSaveError && (
                    <Form.Text
                      id="problem-number-save-error"
                      role="alert"
                      className="text-danger"
                      data-testid="problem-number-save-error"
                    >
                      {numberSaveError}
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="incidentNumber">
                  <Form.Label>Incident Number</Form.Label>
                  {/* US2085183: don't surface the "no incident linked" state while the record is still
                      temporary (unsaved PRBT) — the backend applies the same !temporary guard before an
                      EOC-Bridge incident lookup, so the UI must not get ahead of it during the pre-Save paste. */}
                  {!problem?.temporary &&
                  shouldShowNoIncidentLinked(
                    problem?.incidentNumber,
                    problem?.number,
                  ) ? (
                    <Form.Control
                      plaintext
                      readOnly
                      className="text-danger"
                      value={NO_COMMAND_CENTER_INCIDENT_MESSAGE}
                    />
                  ) : (
                    <Form.Control
                      plaintext
                      readOnly
                      value={problem?.incidentNumber || ""}
                    />
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={9} md={6} lg={6} xl={6}>
                <p>
                  <Form.Label>&nbsp;</Form.Label>
                  {viewLink ? (
                    <>
                      {/* Generated by GitHub Copilot */}
                      {/* Warning button for unexecuted workflows - positioned as specified in Rally story */}
                      {unexecutedWorkflowCount > 0 && (
                        <Button
                          variant="danger"
                          className="controls warning d-flex align-items-center gap-2"
                          onClick={(e) => {
                            e.preventDefault();
                            changeTabs("paging");
                          }}
                          title={`${unexecutedWorkflowCount} unexecuted workflow${
                            unexecutedWorkflowCount !== 1 ? "s" : ""
                          } - click to navigate to Paging tab`}
                        >
                          <FaTriangleExclamation />
                          {unexecutedWorkflowCount}{" "}
                          {unexecutedWorkflowCount === 1
                            ? "Workflow"
                            : "Workflows"}
                        </Button>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </p>
                <div></div>
              </Col>
            </Row>

            <Row>
              {archived ? (
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{ color: "red", fontSize: "1.4em" }}
                >
                  <FaSkull /> &nbsp; This note has been archived and cannot be
                  modified. &nbsp; <FaSkull />
                </Col>
              ) : (
                <></>
              )}
            </Row>
            {/* US2092239: a rejected Status/Impact End save is reported HERE —
                above the tab content, outside every `tabKey === ...` gate — and
                not next to the Status field it concerns.

                The save is fire-and-forget: the MIM sets Status to Resolve on
                Home, then moves to Send Communications while the PATCH is still
                in flight. Rendered inside the "primary" gate this node unmounted
                on that tab change, so a 400 arriving afterwards mounted nothing
                and `role="alert"` never announced. Sending the comm then calls
                setTabKey("history"), so the MIM is never returned to Home — the
                record stayed un-resolved, the dropdown still read "Resolve", and
                a resolution communication had already gone out unchallenged.

                The LeftNavigation save pill does not cover this: useFieldAutoSave
                resets status to "idle" at the top of every save(), and the pill
                only renders when autoSaveStatus !== "idle", so one keystroke in
                any field hides it — and while shown it exposes only the raw
                server message in a title tooltip, not the actionable
                FIELD_SAVE_ERROR_MESSAGES instruction.

                Every message from deriveFieldSaveErrorMessage names its own field
                ("Resolve was not saved: ...", "Impact End was not saved."), so it
                still reads correctly from a tab that has no Status field.

                US2097708 (merge collapse): this is now the ONLY refused-save banner in
                the form, and it reports EVERY field, not just Status / Impact End — the
                duplicate alert that covered the other fields has been removed and its
                input folded in here (see collectRefusedFieldSaves). Its position is
                unchanged and is still the load-bearing part above: outside every
                `tabKey === ...` gate, so a rejection arriving after the MIM has moved
                tabs still mounts and still announces. */}
            {headlineFieldSave && (
              <Row>
                <Col xs={12}>
                  {/* Alert, not Form.Text: this is a record-level alert at the
                      top of the content area, not help text adjacent to an
                      input. Form.Text renders <small class="form-text"> and is
                      sized/positioned for a field it is wired to via
                      aria-describedby (see problem-number-save-error ~:2825);
                      this node has no such owner and must not read as fine
                      print. react-bootstrap's Alert already hardcodes
                      role="alert" on its rendered div (Alert.js), so it is NOT
                      set again here — setting it would be redundant, not
                      additive. No id: nothing references one (the only
                      aria-describedby consumers in this file are
                      problem-number-save-error and pagerduty-help), and a
                      record-level alert spanning Status AND Impact End has no
                      single field that could correctly point at it. */}
                  <Alert
                    variant="danger"
                    className="mb-3"
                    data-testid="field-save-error"
                  >
                    {/* US2097708 (N5): name the field the headline message belongs to.
                        deriveFieldSaveErrorMessage's own copy already names Status or
                        Impact End, but the hook-sourced messages folded in here are
                        field-agnostic ("PATCH failed (500)"), and against a ~20-field
                        form that tells the operator nothing. When no label can be
                        derived the parenthetical is omitted entirely — no "()" and no
                        "undefined". */}
                    <strong>
                      Save failed
                      {headlineLabel ? ` (${headlineLabel})` : ""}:
                    </strong>{" "}
                    {headlineFieldSave.message}
                    {/* US2097708 (F1): once more than one field has an unresolved
                        rejection the headline can only name one of them. List every
                        refused field so none is silently lost -- on a promoted record the
                        409 refuses each field in turn, and "priority was also refused" is
                        the part that tells the MIM what still needs re-entering
                        somewhere else. Omitted entirely at one failure, where the headline
                        already says everything. Testid retained from the removed alert:
                        the list is a distinct affordance with its own assertions, and
                        keeping the hook means it stays independently provable. */}
                    {refusedFieldSaves.length > 1 && (
                      <ul
                        className="mb-0 mt-2"
                        data-testid="autosave-error-fields"
                      >
                        {refusedFieldSaves.map((fieldError, index) => {
                          const label = autoSaveFieldLabel(fieldError.fieldPath);
                          return (
                            <li key={fieldError.fieldPath || index}>
                              {label ? <strong>{label}:</strong> : null}{" "}
                              {fieldError.message}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </Alert>
                </Col>
              </Row>
            )}
            {/* Generated by GitHub Copilot - Tab content without Tabs wrapper */}
            {tabKey === "primary" && (
              <Row>
                <Col xs={12} md={6}>
                  {/* Left Column - Keep existing fields minus date pickers */}
                  <Row className="firstRow">
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="status">
                        <Form.Label>Incident Status</Form.Label>
                        {/* US2092239: CONTROLLED (`value`, not `defaultValue`).
                            `status` state is now the single source of truth for
                            what this dropdown displays, so reverting a cancelled
                            resolve is a plain state update instead of depending
                            on SimpleMenu being redeclared every render to force a
                            remount of an uncontrolled select. */}
                        <SimpleMenu
                          value={status}
                          multiple={false}
                          options={statusOptions}
                          onChange={handleStatusChange}
                          property="status"
                          readOnly={!loaded}
                          disabled={archived}
                          testId="status-select"
                        />
                        {/* US2092239: the rejected-save alert for this field is NOT
                            rendered here. It lives above the tab content so it
                            survives a tab change — see the field-save-error
                            Alert above, outside the `tabKey === "primary"`
                            gate. */}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group
                        className="mb-3"
                        controlId="short_description"
                      >
                        <Form.Label>
                          <FaComment /> &nbsp; Title
                        </Form.Label>

                        {/* maxLength: this field becomes communication.subject on
                            send (sendCommsPayload.js), and from there the title of
                            every subscriber notification. Nothing downstream can cap
                            it without each consumer re-implementing its own clip, so
                            it is bounded where it is typed. The backend bounds it
                            again at a higher ceiling (engine.maxSubjectBytes) for
                            callers that do not come through this form. */}
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={
                            outage && outage.short_description
                              ? outage.short_description
                              : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                          data-testid="title-input"
                          maxLength={500}
                        />
                        <Form.Text className="text-muted">
                          Short Description
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="priority">
                        <Form.Label>Priority</Form.Label>

                        <SimpleMenu
                          multiple={false}
                          options={priorityOptions}
                          onChange={handlePriorityChange}
                          defaultValue={priorityOption}
                          readOnly={!loaded}
                          disabled={archived}
                          testId="priority-select"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Label>
                        Applications, Products or Services
                      </Form.Label>
                      <Form.Group
                        className="mb-3"
                        controlId="impactedApplications"
                      >
                        <SimpleMenu
                          multiple={true}
                          options={configuration.products}
                          onChange={handleImpactedProductChange}
                          readOnly={!loaded}
                          defaultValue={impactedApplications}
                          disabled={archived}
                          testId="impacted-applications-select"
                        />
                        <Form.Text className="text-muted">
                          Changing this field will save all your changes!
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="affectedBrand">
                        <Form.Label>Affected Brand / Capability</Form.Label>
                        <SimpleMenu
                          multiple={true}
                          options={brandOptions}
                          onChange={handleAffectedBrandChange}
                          readOnly={!loaded}
                          defaultValue={affectedBrands}
                          disabled={archived}
                          testId="affected-brand-select"
                        />
                        <Form.Text className="text-muted"></Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="description">
                        <Form.Label>
                          <FaBook /> &nbsp; Current Status
                        </Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "100px" }}
                          placeholder=""
                          value={
                            outage && outage.description
                              ? outage.description
                              : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="commander">
                        <Form.Label>
                          {commanderOverride ? (
                            <HiExclamationTriangle />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <FaUserSecret /> &nbsp; Incident Commander
                        </Form.Label>
                        <CreatableMenu
                          multiple={false}
                          options={commanderOptions}
                          onChange={handleCommanderChange}
                          defaultValue={incidentCommander}
                          creatableCallback={handleCommanderCreate}
                        ></CreatableMenu>
                        <Form.Text className="text-muted">
                          Who's steering this clown car?
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="mim">
                        <Form.Label>
                          <FaUserPen />
                          &nbsp; Major Incident Manager
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={outage && outage.mim ? outage.mim : ""}
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                        <Form.Text className="text-muted">
                          Who's the MIM?
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="businessLiaison">
                        <Form.Label>Business Liaison</Form.Label>
                        <Form.Control
                          size="md"
                          type="text"
                          value={
                            outage && outage.businessLiaison
                              ? outage.businessLiaison
                              : ""
                          }
                          onChange={(e) => {
                            updateProblem(e);
                          }}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="impact">
                        <Form.Label>
                          <FaMeteor /> &nbsp; Client Impact
                        </Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "100px" }}
                          placeholder="Clients are Unable To Access the Website"
                          value={outage && outage.impact ? outage.impact : ""}
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                          data-testid="client-impact-textarea"
                        />
                        <Form.Text className="text-muted">
                          Customer impacted
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="workaround">
                        <Form.Label>Workaround</Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "80px" }}
                          placeholder=""
                          value={
                            outage && outage.workaround ? outage.workaround : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                        <Form.Text className="text-muted">
                          is there one?
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Label>
                        <FaUsers />
                        &nbsp; Affected Users
                      </Form.Label>
                      <SimpleMenu
                        defaultValue={affectedUserOption}
                        options={affectedUserOptions}
                        loading={false}
                        onChange={handleAffectedUsersChange}
                      ></SimpleMenu>
                    </Col>
                  </Row>
                  {showExternalMessage ? (
                    <Row>
                      <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                        <Form.Group
                          className="mb-3"
                          controlId="messageForClients"
                        >
                          <Form.Label>Message to Clients</Form.Label>
                          <Form.Control
                            type="text"
                            as="textarea"
                            style={{ height: "80px" }}
                            placeholder=""
                            value={
                              outage && outage.messageForClients
                                ? outage.messageForClients
                                : ""
                            }
                            onChange={updateProblem}
                            readOnly={!loaded}
                            disabled={archived}
                          />
                          <Form.Text className="text-muted">
                            What do we tell them?
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="numberOfContacts">
                        <Form.Label>
                          <FaUsers />
                          &nbsp; Number of Contacts
                        </Form.Label>
                        <Form.Control
                          size="md"
                          type="text"
                          value={
                            outage && outage.numberOfContacts
                              ? outage.numberOfContacts
                              : ""
                          }
                          onChange={(e) => {
                            updateProblem(e);
                          }}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="salesForceCase">
                        <Form.Label>
                          <FaSalesforce /> &nbsp; SalesForce Ticket Number
                        </Form.Label>
                        <Form.Control
                          type="text"
                          onChange={updateProblem}
                          value={
                            outage && outage.salesForceCase
                              ? outage.salesForceCase
                              : ""
                          }
                          readOnly={!loaded}
                          disabled={archived}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="technicalStatus">
                        <Form.Label>Technical Status</Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "80px" }}
                          placeholder=""
                          value={
                            outage && outage.technicalStatus
                              ? outage.technicalStatus
                              : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="perceivedCause">
                        <Form.Label>Perceived Cause</Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "80px" }}
                          placeholder=""
                          value={
                            outage && outage.perceivedCause
                              ? outage.perceivedCause
                              : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                        <Form.Text className="text-muted">
                          What's the cause?
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="currentApproach">
                        <Form.Label>Current Approach</Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "80px" }}
                          placeholder=""
                          value={
                            outage && outage.currentApproach
                              ? outage.currentApproach
                              : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="vendorTicket">
                        <Form.Label>
                          <FaAws /> &nbsp; Vendor Ticket Number
                        </Form.Label>
                        <Form.Control
                          type="text"
                          onChange={updateProblem}
                          value={
                            outage && outage.vendorTicket
                              ? outage.vendorTicket
                              : ""
                          }
                          readOnly={!loaded}
                          disabled={archived}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="awsAccount">
                        <Form.Label>
                          <FaAws /> &nbsp; AWS Account Number/Alias
                        </Form.Label>
                        <Form.Control
                          type="text"
                          onChange={updateProblem}
                          value={
                            outage && outage.awsAccount ? outage.awsAccount : ""
                          }
                          readOnly={!loaded}
                          disabled={archived}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Form.Group className="mb-3" controlId="slackChannel">
                        <Form.Label>
                          <FaSlack /> &nbsp; Incident Slack Room
                        </Form.Label>
                        <SimpleMenu
                          multiple={false}
                          options={slackChannels}
                          defaultValue={slack}
                          onChange={handleSlackChange}
                          readOnly={!loaded}
                          disabled={archived}
                        ></SimpleMenu>
                        <Form.Text className="text-muted">
                          Slack Channel for Updates
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={6}>
                  {/* Right Column - Date picker fields */}
                  <Row className="firstRow">
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="nextUpdate">
                        <Form.Label>
                          <FaCalendarDay />
                          &nbsp; Next Update
                        </Form.Label>
                        <Row>
                          <Col xs={10} md={9}>
                            <DatePicker
                              selected={nextUpdate}
                              onChange={onNextUpdateChange}
                              showTimeSelect
                              dateFormat={dateFormat}
                              timeFormat="hh:mm a"
                              timeIntervals={5}
                              filterDate={(d) => {
                                return isAfter(d, new Date());
                              }}
                            />
                          </Col>
                          <Col xs={2} md={3}>
                            <Button
                              variant="warning"
                              onClick={(e) => {
                                e.preventDefault();

                                // Capture old value before clearing
                                const oldValue = nextUpdate
                                  ? nextUpdate.getTime()
                                  : null;
                                const newValue = 0;

                                setNextUpdate();
                                let currentOutage = outage;
                                currentOutage.nextUpdate = newValue;
                                setOutage({
                                  ...outage,
                                  nextUpdate: currentOutage.nextUpdate,
                                });
                                problem.outages[outageNumber] = currentOutage;
                                setProblem(problem);
                                setSaved(false);

                                // Trigger auto-save (debounced 1000ms)
                                handleFieldChangeWithAutoSave(
                                  "next_update",
                                  newValue,
                                  oldValue,
                                );
                              }}
                            >
                              <FaMeteor />
                            </Button>
                          </Col>
                        </Row>
                        <Form.Text className="text-muted">
                          Date/Time of next communication
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="incidentStart">
                        <Form.Label>
                          <FaCalendarDay />
                          &nbsp; Impact Begin
                        </Form.Label>
                        <Row>
                          <Col data-testid="incident-start-datepicker">
                            <DatePicker
                              selected={incidentStart}
                              onChange={onStartChange}
                              showTimeSelect
                              dateFormat={dateFormat}
                              timeFormat="hh:mm a"
                              timeIntervals={5}
                              filterDate={(d) => {
                                return isBefore(d, new Date());
                              }}
                            />
                          </Col>
                        </Row>

                        <Form.Text className="text-muted">
                          Date/Time Incident Began
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="incidentEnd">
                        <Form.Label>
                          <FaCalendarDay />
                          &nbsp; Impact End
                        </Form.Label>
                        <Row>
                          <Col
                            xs={10}
                            md={9}
                            data-testid="incident-end-datepicker"
                          >
                            <DatePicker
                              selected={incidentEnd}
                              onChange={onEndChange}
                              showTimeSelect
                              dateFormat={dateFormat}
                              timeFormat="hh:mm a"
                              timeIntervals={5}
                              // showTimeInput
                              filterTime={(d) => {
                                return incidentStart < d.getTime();
                              }}
                              filterDate={(d) => {
                                const startMidnight = subMinutes(
                                  startOfDay(incidentStart),
                                  1,
                                );

                                return isAfter(d, startMidnight);
                              }}
                            />
                          </Col>
                          <Col xs={2} md={3}>
                            <Button
                              variant="warning"
                              onClick={(e) => {
                                e.preventDefault();

                                // Capture old value before clearing
                                const oldValue = incidentEnd
                                  ? incidentEnd.getTime()
                                  : null;
                                const newValue = 0;

                                setIncidentEnd();
                                let currentOutage = outage;
                                currentOutage.incidentEnd = newValue;

                                setOutage({
                                  ...outage,
                                  incidentEnd: currentOutage.incidentEnd,
                                });
                                problem.outages[outageNumber] = currentOutage;
                                setProblem(problem);
                                setSaved(false);

                                // Trigger auto-save (debounced 1000ms)
                                handleFieldChangeWithAutoSave(
                                  "incident_end",
                                  newValue,
                                  oldValue,
                                );
                              }}
                            >
                              <FaMeteor />
                            </Button>
                          </Col>
                        </Row>

                        <Form.Text className="text-muted">
                          Date/Time Impact Ended
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="timeDetected">
                        <Form.Label>
                          <FaCalendarDay />
                          &nbsp; Time Detected
                        </Form.Label>
                        <Row>
                          <Col xs={10} md={9}>
                            <DatePicker
                              selected={timeDetected}
                              onChange={onDetectedChange}
                              showTimeSelect
                              dateFormat={dateFormat}
                              timeFormat="hh:mm a"
                              timeIntervals={5}
                              filterDate={(d) => {
                                return isBefore(d, new Date());
                              }}
                            />
                          </Col>

                          <Col xs={2} md={3}>
                            <Button
                              variant="warning"
                              onClick={(e) => {
                                e.preventDefault();

                                // Capture old value before clearing
                                const oldValue = timeDetected
                                  ? timeDetected.getTime()
                                  : null;
                                const newValue = 0;

                                setTimeDetected();
                                let currentOutage = outage;
                                currentOutage.timeDetected = newValue;

                                setOutage({
                                  ...outage,
                                  timeDetected: currentOutage.timeDetected,
                                });
                                problem.outages[outageNumber] = currentOutage;
                                setProblem(problem);
                                setSaved(false);

                                // Trigger auto-save (debounced 1000ms)
                                handleFieldChangeWithAutoSave(
                                  "time_detected",
                                  newValue,
                                  oldValue,
                                );
                              }}
                            >
                              <FaMeteor />
                            </Button>
                          </Col>
                        </Row>

                        <Form.Text className="text-muted">
                          Date/Time Incident Detected By Montoring
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-2" controlId="eocNotification">
                        <Form.Label>
                          <FaCalendarDay />
                          &nbsp; Command Center Notified
                        </Form.Label>
                        <Row>
                          <Col xs={10} md={9}>
                            <DatePicker
                              selected={eocNotified}
                              onChange={onEOCNotifiedChange}
                              showTimeSelect
                              dateFormat={dateFormat}
                              timeFormat="hh:mm a"
                              timeIntervals={5}
                              filterTime={(d) => {
                                return incidentStart < d.getTime();
                              }}
                              filterDate={(d) => {
                                const startMidnight = subMinutes(
                                  startOfDay(incidentStart),
                                  1,
                                );

                                return isAfter(d, startMidnight);
                              }}
                            />
                          </Col>
                          <Col xs={2} md={3}>
                            <Button
                              variant="warning"
                              onClick={(e) => {
                                e.preventDefault();

                                // Capture old value before clearing
                                const oldValue = eocNotified
                                  ? eocNotified.getTime()
                                  : null;
                                const newValue = 0;

                                setEOCNotified();
                                let currentOutage = outage;
                                currentOutage.eocNotified = newValue;

                                setOutage({
                                  ...outage,
                                  eocNotified: currentOutage.eocNotified,
                                });
                                problem.outages[outageNumber] = currentOutage;
                                setProblem(problem);
                                setSaved(false);

                                // Trigger auto-save (debounced 1000ms)
                                handleFieldChangeWithAutoSave(
                                  "eoc_notified",
                                  newValue,
                                  oldValue,
                                );
                              }}
                            >
                              <FaMeteor />
                            </Button>
                          </Col>
                        </Row>

                        <Form.Text className="text-muted">
                          Command Center Notified
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="techTimeResolved">
                        <Form.Label>
                          <FaCalendarDay />
                          &nbsp; Technical Time of Resolution
                        </Form.Label>
                        <Row>
                          <Col xs={10} md={9}>
                            <DatePicker
                              selected={techTimeResolved}
                              onChange={onTechTimeResolvedChange}
                              showTimeSelect
                              dateFormat={dateFormat}
                              timeFormat="hh:mm a"
                              timeIntervals={5}
                              filterDate={(d) => {
                                return isBefore(d, new Date());
                              }}
                            />
                          </Col>
                          <Col xs={2} md={3}>
                            <Button
                              variant="warning"
                              onClick={(e) => {
                                e.preventDefault();

                                // Capture old value before clearing
                                const oldValue = techTimeResolved
                                  ? techTimeResolved.getTime()
                                  : null;
                                const newValue = 0;

                                setTechTimeResolved();
                                let currentOutage = outage;
                                currentOutage.techTimeResolved = newValue;

                                setOutage({
                                  ...outage,
                                  techTimeResolved:
                                    currentOutage.techTimeResolved,
                                });
                                problem.outages[outageNumber] = currentOutage;
                                setProblem(problem);
                                setSaved(false);

                                // Trigger auto-save (debounced 1000ms)
                                handleFieldChangeWithAutoSave(
                                  "tech_time_resolved",
                                  newValue,
                                  oldValue,
                                );
                              }}
                            >
                              <FaMeteor />
                            </Button>
                          </Col>
                        </Row>

                        <Form.Text className="text-muted">
                          Date/Time Technical Issues Resolved
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {tabKey === "paging" && (
              <Container>
                <Row className="firstRow">
                  {!archived ? (
                    <Col xs={12} lg={12} md={12} xl={12} className="pagerduty">
                      <Form.Group className="mb-3" controlId="pagerDutyButton">
                        <Form.Label>
                          <FaPager />
                          &nbsp;Pager Duty
                        </Form.Label>

                        {pagerDutyIncident && !pdIncidentNotFound ? (
                          <PageLeadership
                            NewRelic={NewRelic}
                            incident={pagerDutyIncident}
                            problem={problem}
                            outage={outage}
                            configuration={
                              configuration && configuration.pagerduty
                            }
                            // Generated by GitHub Copilot
                            // Use consolidated workflow data from backend - legacy workflow props removed
                            consolidatedWorkflows={
                              outage && outage.consolidatedWorkflows
                            }
                            priority={priorityOption.label}
                            impactedApplications={impactedApplications}
                            workflowsExecuted={
                              outage && outage.workflow_invocations
                            }
                            brands={affectedBrands}
                            showPagingForm={showPagingForm}
                            missingCriteria={missingPagingCriteria}
                            disconnectPagerDuty={disconnectPagerDuty}
                            // Generated by GitHub Copilot
                            // Callback to notify parent component of unexecuted workflow count changes
                            onUnexecutedCountChange={
                              handleUnexecutedWorkflowCountChange
                            }
                            // US1989003: loading indicator + stale warning (AC1, AC3)
                            workflowsRefreshing={workflowsRefreshing}
                            isStale={isStale}
                            workflowLoadError={workflowLoadError}
                          ></PageLeadership>
                        ) : (
                          <Form.Group className="mb-3" controlId="pagerduty">
                            {/* US2083214: a stored id PagerDuty does not recognize
                                has no path forward — you cannot page with it and its
                                timeline link goes nowhere. So it is treated as NOT
                                attached (the branch above) and the user gets this box
                                to enter a replacement, with a soft warning naming the
                                value that failed so they can see what was pulled.
                                Covers both an invalid id stored on the outage and one
                                ServiceNow holds that never attached (the backend falls
                                back to the ServiceNow value). Typing a new id saves
                                through the existing PATCH gate, which overwrites the
                                bad value. */}
                            {pdIncidentNotFound && (
                              <div
                                role="alert"
                                data-testid="pd-invalid-attached-id"
                                style={{
                                  display: "block",
                                  color: "#e0a800",
                                  marginBottom: "0.5rem",
                                }}
                              >
                                No PagerDuty incident found for &quot;
                                {pdInvalidIncidentID}&quot; — enter a valid incident ID
                                below.
                              </div>
                            )}
                            <Form.Label>Incident ID</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder=""
                              value={enteredPagerDutyIncident}
                              aria-describedby="pagerduty-help pagerduty-message"
                              aria-invalid={
                                pagerDutyFieldMessage &&
                                pagerDutyFieldMessage.variant === "error"
                                  ? true
                                  : undefined
                              }
                              // US2080752: onChange stays LOCAL-ONLY (keeps the
                              // input controlled) so per-keystroke typing never
                              // fires the live PagerDuty existence check. The
                              // save/validate fires on paste, blur, and Enter;
                              // savePagerDutyIncident dedupes by value so these
                              // triggers can't double-fire the same value.
                              onChange={(e) => {
                                setEnteredPagerDutyIncident(e.target.value);
                              }}
                              onPaste={(e) => {
                                // Let the paste apply, then read the resulting
                                // input value on the next tick, sync it into
                                // state, and save with that value.
                                const inputEl = e.target;
                                setTimeout(() => {
                                  const pastedValue = inputEl.value;
                                  setEnteredPagerDutyIncident(pastedValue);
                                  savePagerDutyIncident(pastedValue);
                                }, 0);
                              }}
                              onBlur={() => {
                                savePagerDutyIncident(enteredPagerDutyIncident);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  savePagerDutyIncident(
                                    enteredPagerDutyIncident,
                                  );
                                }
                              }}
                            />
                            <Form.Text
                              id="pagerduty-help"
                              className="text-muted"
                            >
                              Paste or type an incident ID or URL — saves
                              automatically when you leave the field.
                            </Form.Text>
                          </Form.Group>
                        )}
                        {/* US2080752: render the inline message OUTSIDE the
                            input/PageLeadership ternary so it survives the flip.
                            On a 200-with-warning, savePagerDutyIncident
                            sets the amber warning AND flips to PageLeadership in
                            the same React 18 batched commit; keeping the message
                            here lets the amber warning actually paint in the
                            flipped state, while the red 400 error still shows in
                            the (non-flipped) input state. */}
                        {pagerDutyFieldMessage && (
                          <Form.Text
                            id="pagerduty-message"
                            role={
                              pagerDutyFieldMessage.variant === "error"
                                ? "alert"
                                : "status"
                            }
                            style={{
                              display: "block",
                              color:
                                pagerDutyFieldMessage.variant === "error"
                                  ? "#dc3545"
                                  : "#e0a800",
                            }}
                          >
                            {pagerDutyFieldMessage.text}
                          </Form.Text>
                        )}
                      </Form.Group>
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </Container>
            )}
            {tabKey === "communications" && (
              <>
                <Container>
                  <Row>
                    <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                      {requiredCommunicationFieldsMissing ? (
                        <>
                          <Form.Label style={{ color: "red" }}>
                            <FaSkull /> &nbsp; <FaDumpsterFire /> &nbsp;{" "}
                            <FaRadiation /> &nbsp;
                            <FaTriangleExclamation /> &nbsp;{" "}
                            <FaSkullCrossbones /> &nbsp; Missing Required Fields
                            &nbsp; <FaSkullCrossbones /> &nbsp;{" "}
                            <FaTriangleExclamation /> &nbsp; <FaRadiation />{" "}
                            &nbsp; <FaDumpsterFire /> &nbsp;
                            <FaSkull />
                          </Form.Label>
                          {requiredFieldsMarkup}
                        </>
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.half} md={cs.half} lg={cs.half} xl={cs.half}>
                      <Form.Label>Select a Template</Form.Label>
                      <SimpleMenu
                        defaultValue={templateOption}
                        options={templateOptions}
                        loading={false}
                        onChange={(o) => {
                          if (o) {
                            try {
                              NewRelic?.addPageAction('Communication.TemplateSelected', {
                                template_type: o.type || 'unknown',
                                problemNumber: problem?.number,
                                outage: outage?.number,
                              });
                            } catch (err) {
                              console.warn('[ProblemForm] Communication.TemplateSelected tracking failed:', err);
                            }
                          }
                          setTemplateOption(o);
                        }}
                        required={true}
                        testId="comms-template-select"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Reported Issue</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        disabled={!showReportedIssue}
                        placeholder={
                          showReportedIssue
                            ? ""
                            : "Not needed for this template"
                        }
                        onChange={(e) => {
                          setReportedIssue(e.target.value);
                        }}
                        value={showReportedIssue ? reportedIssue : ""}
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Slack/SMS Communication</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={slackSmsCommunication}
                        onChange={(e) => {
                          setSlackSmsCommunication(e.target.value);
                        }}
                        data-testid="comms-slack-sms-communication"
                      ></Form.Control>
                    </Col>
                  </Row>
                  {/* Generated by GitHub Copilot */}
                  <StatusPageSelector
                    targets={publishingTargets}
                    onTargetsChange={setPublishingTargets}
                    groupOptions={groupOptions}
                    showExistingTargetsLabel={true}
                    showDivider={true}
                    columnSize={5}
                  />

                  {/* US1873550: Read-only reported impacts field */}
                  <Row className="mt-3">
                    <Col>
                      <Form.Label>Reported Impacts</Form.Label>
                      {reportedImpactsLoading ? (
                        <div className="text-muted">Loading impacts…</div>
                      ) : reportedImpacts.length === 0 ? (
                        <div className="text-muted fst-italic">No impacts reported</div>
                      ) : (
                        <ul className="mb-0 ps-3">
                          {reportedImpacts.map((ri) => (
                            <li key={ri.id}>
                              {ri.status && (
                                <span className={`badge me-1 ${ri.status?.toLowerCase() === "active" ? "bg-danger" : "bg-secondary"}`}>
                                  {capitalize(ri.status)}
                                </span>
                              )}
                              <strong>{ri.brand}</strong>
                              {" – "}
                              {ri.applicationName}
                              {ri.childIncidentNumber ? ` (${ri.childIncidentNumber})` : ""}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Col>
                  </Row>

                  {/* Error display for communication failures */}
                  {sendError && (
                    <Row>
                      <Col>
                        <Alert variant="danger" className="mt-3">
                          <strong>Error:</strong> {sendError}
                        </Alert>
                      </Col>
                    </Row>
                  )}
                  {/* Success display for peer review requests */}
                  {peerReviewSuccess && (
                    <Row>
                      <Col>
                        <Alert variant="success" className="mt-3">
                          <strong>Success:</strong> {peerReviewSuccess}
                        </Alert>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <Button
                        variant="primary"
                        disabled={
                          publishingTargets.length === 0 ||
                          requiredCommunicationFieldsMissing ||
                          !templateOption
                        }
                        onClick={(e) => {
                          try {
                            NewRelic?.addPageAction('Communication.PreviewRendered', {
                              template_type: templateOption?.type || 'unknown',
                              problemNumber: problem?.number,
                              outage: outage?.number,
                              // Note: always true at runtime — Preview is disabled while
                              // requiredCommunicationFieldsMissing is true, so this event
                              // can only fire when that flag is already false.
                              merge_fields_populated: !requiredCommunicationFieldsMissing,
                            });
                          } catch (err) {
                            console.warn('[ProblemForm] Communication.PreviewRendered tracking failed:', err);
                          }
                          setShowPreviewModal(true);
                        }}
                        data-testid="comms-preview-button"
                      >
                        Preview
                      </Button>
                      {" "}
                      <Button
                        variant="info"
                        onClick={() => {
                          requestPeerReview();
                        }}
                        disabled={
                          requiredCommunicationFieldsMissing ||
                          !templateOption ||
                          isRequestingPeerReview
                        }
                      >
                        {isRequestingPeerReview ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-label="Requesting peer review"
                              className="me-2"
                            />
                            Requesting...
                          </>
                        ) : (
                          "Peer Review"
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Container>
                <Modal
                  show={showPreviewModal}
                  centered
                  size="lg"
                  onHide={() => {
                    setShowPreviewModal(false);
                  }}
                  data-testid="comms-preview-modal"
                >
                  <Modal.Header closeButton>Communication Preview</Modal.Header>
                  <Modal.Body>
                    {/* Rendered only while open, so the payload is built only then and each
                        open fetches a fresh preview. */}
                    {showPreviewModal && (
                      <SlackCardPreview
                        problemNumber={problem?.number}
                        outageNumber={outage?.number}
                        // The preview endpoint takes the outage id from the body, not the path
                        // (free-text ids are unsafe there); the send payload itself must not
                        // carry outage, since AttachCommunications persists it as-is.
                        payload={{ ...buildCurrentSendPayload(), outage: outage?.number }}
                      />
                    )}
                    <Container>
                      <Row>
                        <Col>
                          <Form.Label>Next Update</Form.Label>
                        </Col>
                        <Col>
                          <Col>
                            {dayjs(nextUpdate).format(previewDateFormat)}
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Email Subject</Form.Label>
                        </Col>
                        <Col>
                          {outage?.short_description}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Severity</Form.Label>
                        </Col>
                        <Col>{priorityOption && priorityOption.label}</Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>
                            Applications, Products or Services
                          </Form.Label>
                        </Col>
                        <Col>
                          {impactedApplications &&
                            impactedApplications.map((aps) => {
                              return <p key={aps.label}>{aps.label}</p>;
                            })}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Affected Brand / Capability</Form.Label>
                        </Col>
                        <Col>
                          {affectedBrands &&
                            affectedBrands.map((aps) => {
                              return <p key={aps.label}>{aps.label}</p>;
                            })}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Current Status</Form.Label>
                        </Col>
                        <Col>{outage && outage.description}</Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Incident Commander</Form.Label>
                        </Col>
                        <Col>
                          {incidentCommander ? incidentCommander.label : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Incident Manager</Form.Label>
                        </Col>
                        <Col>{outage && outage.mim ? outage.mim : "None"}</Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Client Impact</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.impact ? outage.impact : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Workaround</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.workaround ? outage.workaround : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Affected Users</Form.Label>
                        </Col>
                        <Col>
                          {affectedUserOption && affectedUserOption.label
                            ? affectedUserOption.label
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Message for Clients</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.messageForClients
                            ? outage.messageForClients
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Number of Contacts</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.numberOfContacts
                            ? outage.numberOfContacts
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Incident Start</Form.Label>
                        </Col>
                        <Col>
                          {incidentStart
                            ? dayjs(incidentStart).format(previewDateFormat)
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Incident End</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.incidentEnd
                            ? dayjs(outage.incidentEnd).format(
                                previewDateFormat,
                              )
                            : "not set"}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Time Detected</Form.Label>
                        </Col>
                        <Col>
                          {timeDetected
                            ? dayjs(timeDetected).format(previewDateFormat)
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>EOC Notified</Form.Label>
                        </Col>
                        <Col>
                          <Col>
                            {eocNotified
                              ? dayjs(eocNotified).format(previewDateFormat)
                              : ""}
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Time of Technical Resolution</Form.Label>
                        </Col>
                        <Col>
                          <Col>
                            {techTimeResolved
                              ? dayjs(techTimeResolved).format(
                                  previewDateFormat,
                                )
                              : ""}
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Technical Status</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.technicalStatus
                            ? outage.technicalStatus
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Perceived Cause</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.perceivedCause
                            ? outage.perceivedCause
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Label>Slack Channel</Form.Label>
                        </Col>
                        <Col>
                          {outage && outage.slackChannel
                            ? outage.slackChannel
                            : ""}
                        </Col>
                      </Row>
                      {/* US1873550: Show reported impacts in the preview modal */}
                      <Row>
                        <Col>
                          <Form.Label>Reported Impacts</Form.Label>
                        </Col>
                        <Col>
                          {reportedImpactsLoading ? (
                            <span className="text-muted">Loading impacts…</span>
                          ) : reportedImpacts.length === 0 ? (
                            <span className="text-muted fst-italic">No impacts reported</span>
                          ) : (
                            reportedImpacts.map((ri) => (
                              <p key={ri.id} className="mb-1">
                                {ri.status && (
                                  <span className={`badge me-1 ${ri.status?.toLowerCase() === "active" ? "bg-danger" : "bg-secondary"}`}>
                                    {capitalize(ri.status)}
                                  </span>
                                )}
                                <strong>{ri.brand}</strong>
                                {" – "}
                                {ri.applicationName}
                                {ri.childIncidentNumber ? ` (${ri.childIncidentNumber})` : ""}
                              </p>
                            ))
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Button
                            variant="success"
                            onClick={(e) => {
                              attachCommunication();
                            }}
                            disabled={isSendingCommunication}
                            data-testid="comms-send-button"
                          >
                            {/* Generated by GitHub Copilot - Loading spinner for send operation (US1778407) */}
                            {isSendingCommunication ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-label="Sending communication"
                                  className="me-2"
                                />
                                Sending...
                              </>
                            ) : (
                              "Send"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Container>
                  </Modal.Body>
                </Modal>
              </>
            )}
            {tabKey === "history" && (
              <Container>
                <Row>
                  <Col xs={12}>
                    <h5>
                      <FaComment className="me-2" />
                      Communications History
                    </h5>
                    {communications && (
                      <FormatComms communications={communications} />
                    )}
                  </Col>
                </Row>
              </Container>
            )}
            {tabKey === "impacts" &&
              problem &&
              problem.number &&
              !problem.temporary && (
                <Container>
                  <Row>
                    <Col xs={12}>
                      <h5>
                        <FaMeteor className="me-2" />
                        Impact Reports
                      </h5>
                      <Row>
                        <Col className="priorityDescription">
                          My Reports are highlighted in blue and listed first
                        </Col>
                      </Row>
                      <ImpactReportsViewer
                        problemNumber={problem.number}
                        user={user}
                        refreshTrigger={0}
                      />
                    </Col>
                  </Row>
                </Container>
              )}
            {tabKey === "revisions" && (
              <Container>
                <Row>
                  <Col xs={12}>
                    <h5>
                      <FaHistory className="me-2" />
                      Document Version History ({versionCount} versions)
                    </h5>
                    {params.id && (
                      <VersionHistory
                        ref={versionHistoryRef}
                        problemId={params.id}
                        onVersionRestore={handleVersionRestore}
                        onVersionCountChange={handleVersionCountChange}
                        onBeforeNavigate={requestExit}
                      />
                    )}
                  </Col>
                </Row>
              </Container>
            )}
            {tabKey === "timeline" && (
              <>
                <NotesTab
                  notes={notes}
                  problem={problem}
                  outage={outage}
                  postIt={NotesAPI.post}
                  setOutage={setOutage}
                  controls={true}
                />
                <Container>
                  <Row className="firstRow">
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="attendees">
                        <Form.Label>
                          <FaUsers />
                          &nbsp; Attendees
                        </Form.Label>
                        <Form.Control
                          type="text"
                          as="textarea"
                          style={{ height: "100px" }}
                          placeholder="Enter attendee names (e.g., John Doe, Jane Smith)"
                          value={
                            outage && outage.attendees ? outage.attendees : ""
                          }
                          onChange={updateProblem}
                          disabled={archived || !loaded}
                          readOnly={!loaded}
                          data-testid="attendees-input"
                        />
                        <Form.Text className="text-muted">
                          Who attended? (Saved with main save button)
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                      <Form.Group className="mb-3" controlId="PIRContact">
                        <Form.Label>PIR Contact</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={
                            outage && outage.PIRContact ? outage.PIRContact : ""
                          }
                          onChange={updateProblem}
                          readOnly={!loaded}
                          disabled={archived}
                        />
                        <Form.Text className="text-muted">
                          Who gets the call?
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Container>
              </>
            )}
            {tabKey === "reporting" && (
              <Container>
                <Row>
                  <Col xs={cs.full} md={cs.full} lg={cs.full} xl={cs.full}>
                    <ReportingAccordion outage={outage} />
                  </Col>
                </Row>
              </Container>
            )}
          </Col>
        </Row>
      </>
    </LightModeLayout>
  );
}

export default ProblemForm;
